(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biome-bloat-absorption"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAbs(root) {
      var pairs = root.querySelectorAll('[data-bx-abs-pair]');
      function reveal() { pairs.forEach(function (p) { p.classList.add('bloat-abs__pair--in'); }); }
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { reveal(); obs.disconnect(); }
        }, { threshold: 0.3 });
        obs.observe(root);
      } else { reveal(); }
    }
    function boot() { document.querySelectorAll('[data-bx-abs]').forEach(initAbs); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bloat-duo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDuo(root) {
      var cfgEl = root.querySelector('[data-bx-duo-config]');
      var cfg = {};
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
      var buy = root.querySelector('[data-bx-duo-buy]');
      var pick = root.querySelector('[data-bx-duo-pick]');
      var start = root.querySelector('[data-bx-duo-start]');
      var back = root.querySelector('[data-bx-duo-back]');
      var choices = root.querySelectorAll('[data-bx-duo-choose]');

      function showPick() { if (buy) buy.hidden = true; if (pick) pick.hidden = false; }
      function showBuy() { if (pick) pick.hidden = true; if (buy) buy.hidden = false; }

      if (start) start.addEventListener('click', showPick);
      if (back) back.addEventListener('click', showBuy);

      choices.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var flavor = btn.getAttribute('data-bx-duo-choose');
          var shakeId = cfg[flavor];
          var items = [];
          if (cfg.bloat) items.push({ id: cfg.bloat, quantity: 1, properties: { _duo: 'bloat-shake' } });
          if (shakeId) items.push({ id: shakeId, quantity: 1, properties: { _duo: 'bloat-shake' } });
          if (!items.length) return;
          if (window.BiomeCart && window.BiomeCart.addAndOpen) {
            window.BiomeCart.addAndOpen(items, {}).then(showBuy).catch(showBuy);
          } else {
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
              .then(function () { window.location.href = '/cart'; }).catch(function () {});
          }
          showBuy();
        });
      });
    }
    function boot() { document.querySelectorAll('[data-bx-duo]').forEach(initDuo); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bloat-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      var items = root.querySelectorAll('.faq__item');
      function toggle(item) {
        if (item.hasAttribute('data-bx-nutrition')) return; // nutrition panel hooks this
        var isOpen = item.classList.contains('faq__item--open');
        items.forEach(function (el) { el.classList.remove('faq__item--open'); });
        if (!isOpen) item.classList.add('faq__item--open');
      }
      items.forEach(function (item) {
        item.addEventListener('click', function () { toggle(item); });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(item); }
        });
      });
    }
    function boot() { document.querySelectorAll('[data-bs-faq]').forEach(initFaq); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bloat-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(n) {
      var v = Math.round(Number(n) * 100) / 100;
      return Number.isInteger(v) ? String(v) : v.toFixed(2);
    }
    function initPdp(root) {
      var cfgEl = root.querySelector('[data-bx-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

      var BASE = cfg.base;
      var ONCE = [BASE, BASE - cfg.vol2, BASE - cfg.vol3, BASE - cfg.vol6];
      var SUB = [ONCE[0] - cfg.subDiscount, ONCE[1] - cfg.subDiscount, ONCE[2] - cfg.subDiscount, ONCE[3] - cfg.subDiscount];
      var CAPS = cfg.capsules, DAILY = cfg.daily, FREE = cfg.freeShipMin;
      var DAYS_PER_BOTTLE = CAPS / DAILY;
      var SERVINGS_PER_BOTTLE = DAYS_PER_BOTTLE; // 1 serving = 1 day at DAILY caps/day

      function tier(qty) { if (qty <= 1) return 0; if (qty === 2) return 1; if (qty <= 5) return 2; return 3; }
      function unitPrice(qty, plan) { return (plan === 'sub' ? SUB : ONCE)[tier(qty)]; }
      function totals(qty, plan) {
        var unit = unitPrice(qty, plan);
        var subtotal = +fmt(unit * qty);
        var baseSubtotal = +fmt(BASE * qty);
        var savings = +fmt(baseSubtotal - subtotal);
        var freeShip = subtotal >= FREE;
        var days = qty * DAYS_PER_BOTTLE;
        return { unit: unit, subtotal: subtotal, baseSubtotal: baseSubtotal, savings: savings, freeShip: freeShip, qty: qty, days: days, tier: tier(qty) };
      }

      var state = { qty: 3, preset: '3', plan: cfg.defaultPlan === 'once' ? 'once' : 'sub', freq: 8, freqManual: false };

      function businessEta(n) {
        var d = new Date(); var added = 0;
        while (added < n) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
        return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      }

      // ── Milestone bar (built once, updated in place so the fill transition animates) ──
      function buildMilestone() {
        var sav1 = (ONCE[0] - ONCE[1]).toFixed(0), sav2 = (ONCE[0] - ONCE[2]).toFixed(0), sav3 = (ONCE[0] - ONCE[3]).toFixed(0);
        return '' +
          '<div class="ms-twin" data-ms-root>' +
            '<div class="ms-twin__bar ms-twin__bar--tall" data-ms-bar>' +
              '<div class="ms-twin__fill" data-ms-fill></div>' +
              '<span class="ms-twin__inside" data-ms-inside>' +
                '<span class="ms-twin__inside-icon"><svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M1 4.5h8v6.5H1zM9 6.5h2.7l2.3 2.3v2.2H9z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="4" cy="12.5" r="1.4" fill="currentColor"/><circle cx="12" cy="12.5" r="1.4" fill="currentColor"/></svg></span>' +
                '<span data-ms-shiptext></span>' +
              '</span>' +
              '<span class="ms-twin__dot" style="left:0%" data-ms-dot0></span>' +
              '<span class="ms-twin__dot" style="left:100%" data-ms-dot100></span>' +
            '</div>' +
            '<div class="ms-twin__row ms-twin__row--bot">' +
              '<span class="ms-twin__marker ms-twin__marker--l" style="left:0%"><span class="ms-twin__marker-qty" data-ms-mk0>1 Unit</span></span>' +
              '<span class="ms-twin__marker" style="left:33.33%"><span class="ms-twin__marker-qty" data-ms-mk33q>2</span><span class="ms-twin__marker-perk" data-ms-mk33p>−$' + sav1 + '<span class="ms-twin__marker-perk-unit"> / unit</span></span></span>' +
              '<span class="ms-twin__marker" style="left:66.67%"><span class="ms-twin__marker-qty" data-ms-mk66q>3+</span><span class="ms-twin__marker-perk" data-ms-mk66p>−$' + sav2 + '<span class="ms-twin__marker-perk-unit"> / unit</span></span></span>' +
              '<span class="ms-twin__marker ms-twin__marker--r" style="left:100%"><span class="ms-twin__marker-qty" data-ms-mk100q>6+</span><span class="ms-twin__marker-perk" data-ms-mk100p>−$' + sav3 + '<span class="ms-twin__marker-perk-unit"> / unit</span></span></span>' +
            '</div>' +
          '</div>';
      }
      var msEls = null;
      function cacheMsEls() {
        var q = function (s) { return els.ms.querySelector(s); };
        msEls = {
          root: q('[data-ms-root]'), bar: q('[data-ms-bar]'), fill: q('[data-ms-fill]'),
          inside: q('[data-ms-inside]'), shiptext: q('[data-ms-shiptext]'),
          dot0: q('[data-ms-dot0]'), dot100: q('[data-ms-dot100]'),
          mk0: q('[data-ms-mk0]'), mk33q: q('[data-ms-mk33q]'), mk33p: q('[data-ms-mk33p]'),
          mk66q: q('[data-ms-mk66q]'), mk66p: q('[data-ms-mk66p]'),
          mk100q: q('[data-ms-mk100q]'), mk100p: q('[data-ms-mk100p]')
        };
      }
      function setDot(el, reached, accent, tierVal) {
        var c = reached ? (accent || (tierVal === 3 ? 'var(--terracotta)' : 'var(--forest)')) : 'var(--cream-2)';
        var b = reached ? (accent || (tierVal === 3 ? 'var(--terracotta)' : 'var(--forest)')) : 'var(--sage)';
        el.style.background = c; el.style.borderColor = b;
      }
      function updateMilestone(t) {
        if (!msEls) return;
        var tierVal = t.tier;
        var pct = tierVal === 0 ? 16 : (tierVal === 1 ? 50 : (tierVal === 2 ? 83 : 100));
        var fillColor = tierVal === 3 ? 'var(--terracotta)' : 'var(--forest)';
        msEls.root.classList.toggle('ms-twin--all-full', tierVal === 3);
        msEls.bar.style.setProperty('--ms-pct', pct + '%');
        msEls.fill.style.width = pct + '%';
        msEls.fill.style.background = fillColor;
        msEls.fill.classList.toggle('ms-twin__fill--full', pct >= 100);
        msEls.inside.classList.toggle('ms-twin__inside--on', t.freeShip);
        msEls.shiptext.textContent = t.freeShip ? 'Free shipping unlocked' : 'Free shipping at $' + FREE;
        setDot(msEls.dot0, t.qty >= 1, null, tierVal);
        setDot(msEls.dot100, tierVal === 3, 'var(--terracotta)', tierVal);
        msEls.mk0.style.color = t.qty >= 1 ? 'var(--ink)' : 'var(--ink-2)';
        msEls.mk33q.style.color = t.qty >= 2 ? 'var(--ink)' : 'var(--ink-2)';
        msEls.mk33p.style.color = t.qty >= 2 ? 'var(--forest)' : 'var(--sage)';
        msEls.mk66q.style.color = t.qty >= 3 ? 'var(--ink)' : 'var(--ink-2)';
        msEls.mk66p.style.color = t.qty >= 3 ? 'var(--forest)' : 'var(--sage)';
        msEls.mk100q.style.color = tierVal === 3 ? 'var(--ink)' : 'var(--ink-2)';
        msEls.mk100p.style.color = tierVal === 3 ? 'var(--terracotta-2)' : 'var(--sage)';
      }

      var els = {
        presets: root.querySelectorAll('[data-bx-preset]'),
        qtyVal: root.querySelector('[data-bx-qty-val]'),
        qtyInc: root.querySelector('[data-bx-qty-inc]'),
        qtyDec: root.querySelector('[data-bx-qty-dec]'),
        preset1Sub: root.querySelector('[data-bx-preset-sub="1"]'),
        presetSave3: root.querySelector('[data-bx-preset-save="3"]'),
        presetSave6: root.querySelector('[data-bx-preset-save="6"]'),
        subTag: root.querySelector('[data-bx-sub-tag]'),
        subPps: root.querySelector('[data-bx-sub-pps]'),
        subPpb: root.querySelector('[data-bx-sub-ppb]'),
        subPerk: root.querySelector('[data-bx-sub-perk]'),
        oncePps: root.querySelector('[data-bx-once-pps]'),
        oncePpb: root.querySelector('[data-bx-once-ppb]'),
        servingsTotal: root.querySelector('[data-bx-servings-total]'),
        cadence: root.querySelector('[data-bx-cadence]'),
        eta: root.querySelector('[data-bx-eta]'),
        atc: root.querySelector('[data-bx-atc]'),
        atcLabel: root.querySelector('[data-bx-atc-label]'),
        atcPriceGrp: root.querySelector('[data-bx-atc-pricegrp]'),
        ms: root.querySelector('[data-bx-ms]'),
        freq: root.querySelector('[data-bx-freq]'),
        planSub: root.querySelector('[data-bx-plan="sub"]'),
        planOnce: root.querySelector('[data-bx-plan="once"]'),
        satc: root.querySelector('[data-bx-satc]'),
        satcTitle: root.querySelector('[data-bx-satc-title]'),
        satcSub: root.querySelector('[data-bx-satc-sub]'),
        satcPrice: root.querySelector('[data-bx-satc-price]'),
        satcThumb: root.querySelector('[data-bx-satc-thumb]'),
        satcBtn: root.querySelector('[data-bx-satc-btn]'),
        satcLabel: root.querySelector('[data-bx-satc-label]'),
        navAtcLabel: document.querySelector('[data-bx-navatc-label]'),
        navAtcTitle: document.querySelector('[data-bx-navatc-title]'),
        navAtcStrike: document.querySelector('[data-bx-navatc-strike]'),
        navAtcNum: document.querySelector('[data-bx-navatc-num]')
      };

      function render() {
        var t = totals(state.qty, state.plan);

        // preset cards
        els.presets.forEach(function (card) {
          var id = card.getAttribute('data-bx-preset');
          var on = state.preset === id;
          card.classList.toggle('metab-qty__opt--on', on);
          card.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        // 1-bottle stepper (only shown when preset 1 selected — already in DOM, value updates always)
        if (els.qtyVal) els.qtyVal.textContent = state.qty;
        if (els.qtyDec) { els.qtyDec.disabled = state.qty <= 1; els.qtyDec.classList.toggle('stepper__btn--off', state.qty <= 1); }
        // The 1-bottle card's supply reflects ITS OWN quantity — 1 by default, or the stepper value
        // when it's the active tier — never the qty of whatever fixed tier (3/6) happens to be
        // selected. Otherwise the default 3-bottle tier made the 1-bottle card read "6-week supply".
        var preset1Qty = state.preset === '1' ? state.qty : 1;
        if (els.preset1Sub) els.preset1Sub.textContent = (preset1Qty * DAYS_PER_BOTTLE / 7) + '-week supply';
        // preset 3 / 6 savings
        if (els.presetSave3) { var s3 = BASE - unitPrice(3, state.plan); els.presetSave3.style.visibility = s3 > 0 ? 'visible' : 'hidden'; els.presetSave3.innerHTML = 'Save $' + s3 + '<span class="metab-qty__unit">/bottle</span>'; }
        if (els.presetSave6) { var s6 = BASE - unitPrice(6, state.plan); els.presetSave6.style.visibility = s6 > 0 ? 'visible' : 'hidden'; els.presetSave6.innerHTML = 'Save $' + s6 + '<span class="metab-qty__unit">/bottle</span>'; }

        // plan prices (per-bottle + per-serving for the selected qty)
        var subUnit = unitPrice(state.qty, 'sub'), onceUnit = unitPrice(state.qty, 'once');
        var subPerServing = +fmt(subUnit / SERVINGS_PER_BOTTLE), oncePerServing = +fmt(onceUnit / SERVINGS_PER_BOTTLE);
        var perBottleSav = BASE - subUnit, totalSav = perBottleSav * state.qty;
        if (els.subTag) els.subTag.textContent = 'Save $' + totalSav + ' · most popular';
        if (els.subPps) els.subPps.textContent = '$' + fmt(subPerServing) + ' / serving';
        if (els.subPpb) els.subPpb.innerHTML = '<span class="pln__pricecol-num pln__pricecol-num--sale"><span class="pln__pricecol-strike">$' + fmt(BASE) + '</span>$' + fmt(subUnit) + '<span class="pln__pricecol-unit">/ bottle</span></span>';
        if (els.subPerk) els.subPerk.textContent = '$' + perBottleSav + ' off every bottle, every order';
        if (els.oncePps) els.oncePps.textContent = '$' + fmt(oncePerServing) + ' / serving';
        var showStrike = onceUnit < BASE;
        if (els.oncePpb) els.oncePpb.innerHTML = '<span class="pln__pricecol-num ' + (showStrike ? 'pln__pricecol-num--sale' : '') + '">' + (showStrike ? '<span class="pln__pricecol-strike">$' + fmt(BASE) + '</span>' : '') + '$' + fmt(onceUnit) + '<span class="pln__pricecol-unit">/ bottle</span></span>';

        // plan selected state
        els.planSub.classList.toggle('pln--on', state.plan === 'sub');
        els.planOnce.classList.toggle('pln--on', state.plan === 'once');

        // servings total + cadence + freq
        var servings = state.qty * SERVINGS_PER_BOTTLE;
        if (els.servingsTotal) els.servingsTotal.textContent = servings + ' SERVINGS TOTAL';
        if (els.freq) { els.freq.value = String(state.freq); els.freq.dispatchEvent(new CustomEvent('flipdd:sync')); }
        if (els.cadence) { var spw = servings / state.freq; els.cadence.textContent = '≈ ' + spw.toFixed(spw % 1 === 0 ? 0 : 1) + ' servings / week'; }

        // eta
        var etaStr = businessEta(3);
        els.eta.innerHTML = state.plan === 'sub'
          ? '1st delivery <strong class="bx-eta-strong">' + etaStr + '</strong> then every ' + state.freq + ' weeks'
          : 'Estimated delivery: <strong class="bx-eta-strong">' + etaStr + '</strong>';

        // ATC
        els.atcLabel.textContent = 'Add ' + t.qty + ' ' + (t.qty === 1 ? 'bottle' : 'bottles') + (t.savings > 0 ? ' · Save $' + fmt(t.savings) : '');
        els.atcPriceGrp.innerHTML = (t.savings > 0 ? '<span class="bx-atc-strike">$' + fmt(t.baseSubtotal) + '</span>' : '') + '<span class="bx-atc-total">$' + fmt(t.subtotal) + '</span>';

        if (!msEls) { els.ms.innerHTML = buildMilestone(); cacheMsEls(); }
        updateMilestone(t);

        // sticky ATC
        if (els.satc) {
          els.satcThumb.textContent = t.qty + '×';
          els.satcTitle.textContent = t.qty + ' ' + (t.qty === 1 ? 'bottle' : 'bottles') + ' · ' + (t.qty * DAYS_PER_BOTTLE) + ' days';
          els.satcSub.textContent = (state.plan === 'sub' ? 'Subscribe & save' : 'One-time purchase') + (t.freeShip ? ' · free shipping' : '');
          els.satcPrice.textContent = '$' + fmt(t.subtotal);
          if (els.satcLabel) els.satcLabel.textContent = 'Add to cart';
        }

        // nav smart-ATC (header, compact mode) — mirror the hero selection
        if (els.navAtcLabel) {
          els.navAtcLabel.textContent = t.qty + ' ' + (t.qty === 1 ? 'bottle' : 'bottles') + ' · ' + (state.plan === 'sub' ? 'Subscribe' : 'One-time');
          els.navAtcTitle.textContent = t.days + ' days · $' + fmt(t.unit) + '/bottle';
          if (els.navAtcStrike) {
            if (t.savings > 0) { els.navAtcStrike.hidden = false; els.navAtcStrike.textContent = '$' + fmt(t.baseSubtotal); }
            else els.navAtcStrike.hidden = true;
          }
          els.navAtcNum.textContent = '$' + fmt(t.subtotal);
        }
      }

      // Snap subscription cadence to qty's natural pace (1 bottle ≈ 2 weeks at 4 caps/day).
      function snapFreq() {
        var target = Math.min(state.qty * 2, 12);
        var choices = [2, 4, 6, 8, 10, 12];
        state.freq = choices.reduce(function (a, b) { return Math.abs(b - target) < Math.abs(a - target) ? b : a; });
        state.freqManual = false;        // qty changed → auto cadence wins again
      }

      function selectPreset(id, qty) {
        state.preset = id;
        // Honor the card's own qty (the 1-bottle card carries data-qty="1") so switching from a
        // 3- or 6-bottle tier back to "1 Bottle" resets to 1 instead of carrying the prior tier's
        // quantity through. Matches the metabolism-booster picker. The stepper's +/- buttons
        // stopPropagation, so they adjust qty without re-triggering this card-level reset.
        if (qty != null) state.qty = qty;
        else if (id === '1') state.qty = 1;
        snapFreq();
        render();
      }

      els.presets.forEach(function (card) {
        var id = card.getAttribute('data-bx-preset');
        var qty = Number(card.getAttribute('data-qty'));
        card.addEventListener('click', function () { selectPreset(id, qty); });
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPreset(id, qty); } });
      });
      if (els.qtyInc) els.qtyInc.addEventListener('click', function (e) { e.stopPropagation(); state.qty = state.qty + 1; snapFreq(); render(); });
      if (els.qtyDec) els.qtyDec.addEventListener('click', function (e) { e.stopPropagation(); state.qty = Math.max(1, state.qty - 1); snapFreq(); render(); });
      // Whole plan card is the select target (delegated). Guard real form controls so the
      // frequency <select> still opens without re-selecting the plan.
      root.addEventListener('click', function (e) {
        if (e.target.closest('select, input, option')) return;
        var planSel = e.target.closest('[data-bx-plan-select]');
        if (planSel) { state.plan = planSel.getAttribute('data-bx-plan-select'); render(); }
      });
      if (els.freq) els.freq.addEventListener('change', function () { state.freq = Number(els.freq.value); state.freqManual = true; render(); });

      // ── ATC → (first-time partner nudge) → AJAX add ──
      function commitAdd(qty) {
        if (qty <= 0 || !cfg.variant) return;
        var t = totals(qty, state.plan);
        var props = { _plan: state.plan, _bottles: String(qty) };
        if (state.plan === 'sub') props._delivery_weeks = String(state.freq);
        var items = [{ id: cfg.variant, quantity: qty, properties: props }];
        els.atc.disabled = true;
        if (window.BiomeCart && window.BiomeCart.addAndOpen) {
          window.BiomeCart.addAndOpen(items, { plan: state.plan, freq: state.freq, freqManual: state.freqManual })
            .then(function () { els.atc.disabled = false; })
            .catch(function () { els.atc.disabled = false; });
        } else {
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { window.location.href = '/cart'; })
            .catch(function () { els.atc.disabled = false; });
        }
      }
      function nudgeSeen() { return /(?:^|; )biome_partner_nudge_seen=1(?:;|$)/.test(document.cookie || ''); }
      function markNudgeSeen() { try { document.cookie = 'biome_partner_nudge_seen=1; max-age=' + (60 * 60 * 24 * 365) + '; path=/; samesite=lax'; } catch (e) {} }
      var pn = root.querySelector('[data-bx-nudge]');
      var pnBack = root.querySelector('[data-bx-nudge-back]');
      var pendingQty = 0;
      function openNudge(qty) {
        if (!pn) { commitAdd(qty); return; }
        pendingQty = qty;
        var soloUnit = unitPrice(qty, state.plan);
        var partnerUnit = unitPrice(qty * 2, state.plan);
        var sav = Math.max(0, +fmt(soloUnit - partnerUnit));
        var savEl = root.querySelector('[data-bx-nudge-sav]');
        if (savEl) savEl.innerHTML = sav > 0 ? (' and you\'ll save <b>an extra $' + fmt(sav) + ' per bottle</b>.') : ' shipped in the same box.';
        pn.classList.add('pn--open'); pn.setAttribute('aria-hidden', 'false');
        if (pnBack) pnBack.classList.add('pn-back--open');
        document.body.style.overflow = 'hidden';
      }
      function closeNudge() { if (pn) { pn.classList.remove('pn--open'); pn.setAttribute('aria-hidden', 'true'); } if (pnBack) pnBack.classList.remove('pn-back--open'); document.body.style.overflow = ''; }
      function nudgeSolo() { markNudgeSeen(); closeNudge(); commitAdd(pendingQty || state.qty); }
      function nudgePartner() {
        markNudgeSeen(); closeNudge();
        state.freq = Math.min(12, state.freq * 2);   // 2× the basket → 2× the cadence
        render();
        commitAdd((pendingQty || state.qty) * 2);
      }

      els.atc.addEventListener('click', function () {
        if (state.qty <= 0) return;
        if (cfg.showNudge && !nudgeSeen()) openNudge(state.qty);
        else commitAdd(state.qty);
      });
      root.querySelectorAll('[data-bx-nudge-solo]').forEach(function (b) { b.addEventListener('click', nudgeSolo); });
      root.querySelectorAll('[data-bx-nudge-partner]').forEach(function (b) { b.addEventListener('click', nudgePartner); });
      if (pnBack) pnBack.addEventListener('click', nudgeSolo);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pn && pn.classList.contains('pn--open')) nudgeSolo(); });

      // sticky ATC — reuse the hero ATC handler; surface on scroll past the buy-box
      if (els.satcBtn) els.satcBtn.addEventListener('click', function () { els.atc.click(); });
      var heroAtc = root.querySelector('.atcw');
      function onSatcScroll() {
        if (!els.satc || !cfg.showStickyATC) return;
        var past = heroAtc ? heroAtc.getBoundingClientRect().bottom < 0 : false;
        var fin = document.querySelector('footer.footer, .metab-final, .bs-fcta');
        var atEnd = fin ? fin.getBoundingClientRect().top < (window.innerHeight - 80) : false;
        els.satc.classList.toggle('satc--show', past && !atEnd);
      }
      if (cfg.showStickyATC) { window.addEventListener('scroll', onSatcScroll, { passive: true }); onSatcScroll(); }

      // rotating tagline (cross-fade)
      var taglineEls = root.querySelectorAll('[data-bx-tagline]');
      var taglines = (cfgEl.getAttribute('data-taglines') || '').split('|').filter(Boolean);
      if (taglineEls.length && taglines.length > 1) {
        var ti = 0;
        setInterval(function () {
          taglineEls.forEach(function (el) { el.classList.add('bx-tagline--out'); });
          setTimeout(function () {
            ti = (ti + 1) % taglines.length;
            taglineEls.forEach(function (el) { el.textContent = taglines[ti]; el.classList.remove('bx-tagline--out'); });
          }, 320);
        }, 3200);
      }

      // gallery — main crossfade shots + thumbnails. Both desktop and mobile use a
      // horizontal scroll rail (swipe on touch / drag with a mouse). Desktop caps the
      // rail at 5 thumbs (CSS max-width) and keeps the flanking arrows, which page it.
      var shots = root.querySelectorAll('[data-bx-shot]');
      var thumbs = root.querySelectorAll('[data-bx-thumb]');
      var dots = root.querySelectorAll('[data-bx-dot]');
      var countEl = root.querySelector('[data-bx-count]');
      var track = root.querySelector('[data-bx-thumbs]');
      var tprev = root.querySelector('[data-bx-thumb-prev]'), tnext = root.querySelector('[data-bx-thumb-next]');
      var gi = 0;
      function loadShot(n) {
        var s = shots[n];
        if (s && !s.getAttribute('src') && s.getAttribute('data-bx-shot-src')) { s.setAttribute('src', s.getAttribute('data-bx-shot-src')); }
      }
      // Every thumb lives in the rail (no windowing); fade each thumb img in once it loads (no popping).
      thumbs.forEach(function (b) {
        b.hidden = false;
        var im = b.querySelector('img');
        if (im && !im.complete) { im.classList.add('is-fading'); var on = function () { im.classList.add('is-loaded'); }; im.addEventListener('load', on); im.addEventListener('error', on); }
      });
      // Enable/disable the flanking arrows based on how far the rail is scrolled.
      function syncArrows() {
        if (!track) return;
        var max = track.scrollWidth - track.clientWidth;
        if (tprev) tprev.disabled = track.scrollLeft <= 1;
        if (tnext) tnext.disabled = track.scrollLeft >= max - 1;
      }
      function pageBy(dir) {                                    // arrows scroll the rail by one visible page
        if (!track) return;
        var step = (thumbs.length > 1) ? (thumbs[1].offsetLeft - thumbs[0].offsetLeft) : 74;
        var per = Math.max(1, Math.round(track.clientWidth / step));
        track.scrollBy({ left: dir * per * step, behavior: 'smooth' });
      }
      function setShot(i, skipScroll) {
        if (!shots.length) return;
        var total = shots.length;
        gi = (i + total) % total;
        loadShot(gi); loadShot((gi + 1) % total); loadShot((gi - 1 + total) % total);
        shots.forEach(function (s, n) { s.classList.toggle('bx-shot--on', n === gi); });
        thumbs.forEach(function (b, n) {
          b.classList.toggle('hero-thumbs__btn--on', n === gi);
          b.classList.toggle('hero-thumbs__btn--off', n !== gi);
        });
        if (!skipScroll && thumbs[gi] && thumbs[gi].scrollIntoView) {          // keep the active thumb in view in the rail (not on init — would scroll the page to the gallery)
          thumbs[gi].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
        dots.forEach(function (d, n) { d.classList.toggle('hero-thumbs__dot--on', n === gi); });
        if (countEl) countEl.textContent = ('0' + (gi + 1)).slice(-2) + ' / ' + ('0' + total).slice(-2);
      }
      thumbs.forEach(function (b, n) { b.addEventListener('click', function () { setShot(n); }); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { setShot(n); }); });
      var prev = root.querySelector('[data-bx-prev]'), next = root.querySelector('[data-bx-next]');
      if (prev) prev.addEventListener('click', function () { setShot(gi - 1); });
      if (next) next.addEventListener('click', function () { setShot(gi + 1); });
      // Thumbnail arrows page the rail (desktop) — browse beyond the first five.
      if (tprev) tprev.addEventListener('click', function () { pageBy(-1); });
      if (tnext) tnext.addEventListener('click', function () { pageBy(1); });
      if (track) {
        track.addEventListener('scroll', syncArrows, { passive: true });
        window.addEventListener('resize', syncArrows);
        // Mouse: drag the rail to scroll. Move/up are bound to the window during a drag, so letting
        // go anywhere (even off the rail) reliably ends it. A press that doesn't move selects that
        // thumb on release (snap-proof — uses the thumb you pressed). Touch + keyboard use the
        // thumbs' own click handlers above.
        var down = false, sx = 0, sl = 0, moved = false, pressIdx = -1, ptrType = '', snapRAF = 0;
        function thumbStep() { return thumbs.length > 1 ? (thumbs[1].offsetLeft - thumbs[0].offsetLeft) : 74; }
        function gentleSnap(target) {                           // ease (decelerate) into the nearest thumb edge
          cancelAnimationFrame(snapRAF);
          var startL = track.scrollLeft, dist = target - startL, t0 = 0;
          if (Math.abs(dist) < 1) { track.classList.remove('is-dragging'); return; }
          function tick(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / 340);
            track.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));   // easeOutCubic
            if (p < 1) { snapRAF = requestAnimationFrame(tick); }
            else { track.classList.remove('is-dragging'); }
          }
          snapRAF = requestAnimationFrame(tick);
        }
        function onMove(e) {
          if (!down) return;
          var dx = e.clientX - sx;
          if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }   // a real drag has begun
          if (moved) track.scrollLeft = sl - dx;
        }
        function endDrag() {
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', endDrag);
          window.removeEventListener('pointercancel', endDrag);
          if (!down) return;
          down = false;
          if (moved) { gentleSnap(Math.round(track.scrollLeft / thumbStep()) * thumbStep()); }
          else { track.classList.remove('is-dragging'); if (pressIdx > -1) setShot(pressIdx); }    // a tap selects the pressed thumb
          pressIdx = -1;
        }
        track.addEventListener('pointerdown', function (e) {
          ptrType = e.pointerType;
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          var b = e.target.closest('[data-bx-thumb]');
          pressIdx = b ? Array.prototype.indexOf.call(thumbs, b) : -1;
          down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
          cancelAnimationFrame(snapRAF);                        // grabbing again interrupts an in-flight snap
          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', endDrag);
          window.addEventListener('pointercancel', endDrag);
        });
        // Mouse selection is handled on pointerup (endDrag) — swallow the synthetic mouse click so it
        // neither double-fires nor (after a drag) switches the shot. Touch/keyboard clicks pass through.
        track.addEventListener('click', function (e) { if (ptrType === 'mouse' && e.detail > 0) { e.preventDefault(); e.stopPropagation(); } }, true);
        // Block native image dragging so a drag that starts ON a thumb still scrolls the rail.
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      // Touch: swipe the hero image left/right to change the shot.
      function bxSwipe(el) {
        if (!el) return;
        var sx = 0, sy = 0, st = 0;
        el.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); }, { passive: true });
        el.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) < 36 || Math.abs(dx) <= Math.abs(dy) || Date.now() - st > 800) return;
          setShot(gi + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
      bxSwipe(root.querySelector('[data-bx-gallery]'));
      setShot(0, true); // init: skip the scrollIntoView (would yank the page to the gallery on load)
      syncArrows();

      snapFreq();
      render();
    }
    function boot() { document.querySelectorAll('[data-biome-bloat-pdp]').forEach(initPdp); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bloat-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIng(root) {
      var grid = root.querySelector('[data-bx-ing-grid]');
      var cards = root.querySelectorAll('[data-bx-ing-card]');
      var dots = root.querySelectorAll('[data-bx-ing-dot]');
      if (!grid || !cards.length) return;
      var active = 0;
      function setActive(i) {
        active = i;
        dots.forEach(function (d, n) { d.classList.toggle('metab-ing__dot--on', n === i); d.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      }
      function onScroll() {
        var center = grid.scrollLeft + grid.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (c, i) {
          var cc = c.offsetLeft + c.offsetWidth / 2;
          var d = Math.abs(cc - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (best !== active) setActive(best);
      }
      grid.addEventListener('scroll', onScroll, { passive: true });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var card = cards[i];
          if (card) grid.scrollTo({ left: card.offsetLeft - 16, behavior: 'smooth' });
        });
      });
    }
    function boot() { document.querySelectorAll('[data-bx-bloat-ing]').forEach(initIng); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bloat-pillars"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPillars(root) {
      var tabs = root.querySelectorAll('[data-bx-pillar-tab]');
      var panels = root.querySelectorAll('[data-bx-pillar-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var kind = tab.getAttribute('data-bx-pillar-tab');
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('metab-pillars__tab--on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-bx-pillar-panel') !== kind; });
        });
      });
    }
    function boot() { document.querySelectorAll('[data-bx-pillars]').forEach(initPillars); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bloat-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tagsMatch(el, filter) {
      if (filter === 'all') return true;
      var tags = (el.getAttribute('data-tags') || '').split(',');
      for (var i = 0; i < tags.length; i++) { if (tags[i].trim() === filter) return true; }
      return false;
    }
    function initReviews(root) {
      var PAGE_SIZE = 6, MAX_PAGES = 2, TOTAL_LABEL = '1,964';
      var pills = root.querySelectorAll('[data-bs-filter]');
      var cards = root.querySelectorAll('[data-bs-card]');
      var extras = root.querySelectorAll('[data-bs-extra]');
      var loadBtn = root.querySelector('[data-bs-loadmore]');
      var loadLabel = root.querySelector('[data-bs-loadmore-label]');
      var progress = root.querySelector('[data-bs-progress]');
      var viewAll = root.querySelector('[data-bs-viewall]');
      var readAllText = loadLabel ? loadLabel.textContent : ('Read all ' + TOTAL_LABEL + ' reviews');
      var state = { filter: 'all', pages: 0 };

      function filteredExtras() { var out = []; extras.forEach(function (el) { if (tagsMatch(el, state.filter)) out.push(el); }); return out; }
      function filteredCardCount() { var c = 0; cards.forEach(function (el) { if (tagsMatch(el, state.filter)) c++; }); return c; }

      function render() {
        cards.forEach(function (el) { el.style.display = tagsMatch(el, state.filter) ? '' : 'none'; });
        var matching = filteredExtras();
        var shown = state.pages * PAGE_SIZE;
        extras.forEach(function (el) { el.hidden = true; });
        var shownCount = 0;
        for (var i = 0; i < matching.length && i < shown; i++) { matching[i].hidden = false; shownCount++; }
        var remaining = matching.length - shownCount;
        if (state.pages === 0) {
          loadBtn.hidden = false;
          if (loadLabel) loadLabel.textContent = readAllText;
          progress.hidden = true; viewAll.hidden = true;
        } else if (state.pages < MAX_PAGES && remaining > 0) {
          loadBtn.hidden = false;
          var batch = Math.min(PAGE_SIZE, remaining);
          if (loadLabel) loadLabel.textContent = 'Load ' + batch + ' more reviews';
          progress.hidden = false;
          progress.textContent = 'Showing ' + (filteredCardCount() + shownCount) + ' of ' + TOTAL_LABEL;
          viewAll.hidden = true;
        } else {
          loadBtn.hidden = true; progress.hidden = true; viewAll.hidden = false;
        }
      }
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          state.filter = pill.getAttribute('data-bs-filter');
          state.pages = 0;
          pills.forEach(function (p) { p.classList.remove('sk-rev__pill--on'); });
          pill.classList.add('sk-rev__pill--on');
          render();
        });
      });
      loadBtn.addEventListener('click', function () { state.pages += 1; render(); });
      render();
    }
    function boot() { document.querySelectorAll('[data-bs-bloat-rev]').forEach(initReviews); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bloat-trio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTrio(root) {
      var grid = root.querySelector('[data-bx-trio-grid]');
      var cards = root.querySelectorAll('[data-bx-trio-card]');
      var venns = root.querySelectorAll('[data-bx-venn]');
      var dots = root.querySelectorAll('[data-bx-trio-dot]');
      if (!cards.length) return;
      var COUNT = cards.length;
      var activeIdx = 0;
      var isMobile = false;
      var sectionInView = false;
      var cycleTimer = null;

      // The venn circle that should light up for a given card index — keyed by the
      // card's data-kind so the venn stays in sync regardless of block order.
      function vennForIdx(i) { return cards[i] ? cards[i].getAttribute('data-kind') : null; }

      function apply(i) {
        activeIdx = i;
        cards.forEach(function (c, n) { c.classList.toggle('bloat-trio__card--active', n === i); });
        var kind = vennForIdx(i);
        venns.forEach(function (v) { v.classList.toggle('bloat-venn__circle--active', v.getAttribute('data-bx-venn') === kind); });
        dots.forEach(function (d, n) { d.classList.toggle('bloat-trio__dot--on', n === i); d.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      }

      function startCycle() {
        if (cycleTimer) clearInterval(cycleTimer);
        if (isMobile || !sectionInView) return;
        var i = 0;
        apply(0);
        cycleTimer = setInterval(function () { i = (i + 1) % COUNT; apply(i); }, 2000);
      }
      function stopCycle() { if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; } }

      var mq = window.matchMedia('(max-width: 760px)');
      function applyMq() { isMobile = mq.matches; if (isMobile) { stopCycle(); } else { startCycle(); } }
      applyMq();
      if (mq.addEventListener) mq.addEventListener('change', applyMq); else mq.addListener(applyMq);

      // Start the desktop cycle only once the section scrolls into view.
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { sectionInView = true; startCycle(); obs.disconnect(); }
        }, { threshold: 0.4 });
        obs.observe(root);
      } else { sectionInView = true; startCycle(); }

      // Mobile: detect the centered card on scroll and sync the venn + dots.
      function onScroll() {
        if (!isMobile || !grid) return;
        var center = grid.scrollLeft + grid.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (c, idx) {
          var cc = c.offsetLeft + c.offsetWidth / 2;
          var d = Math.abs(cc - center);
          if (d < bestDist) { bestDist = d; best = idx; }
        });
        if (best !== activeIdx) apply(best);
      }
      if (grid) grid.addEventListener('scroll', onScroll, { passive: true });

      // Dot click → scroll mobile carousel to that card (scroll listener flips active).
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (grid && isMobile) {
            var card = cards[i];
            if (card) grid.scrollTo({ left: card.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
          } else { apply(i); }
        });
      });
    }
    function boot() { document.querySelectorAll('[data-bx-trio]').forEach(initTrio); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBlog(root) {
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-blog-cat]'));
      if (!chips.length) return;
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-blog-item]'));
      var featGrid = root.querySelector('[data-bx-blog-feature-grid]');
      var empty = root.querySelector('[data-bx-blog-empty]');

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var cat = chip.getAttribute('data-blog-cat');
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('blog-chip--on', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var featVisible = 0, gridVisible = 0;
          items.forEach(function (item) {
            var tags = (item.getAttribute('data-tags') || '').split('|');
            var show = cat === 'All' || tags.indexOf(cat) !== -1;
            item.style.display = show ? '' : 'none';
            if (show) {
              if (item.closest('[data-bx-blog-grid]')) gridVisible++;
              else featVisible++;
            }
          });
          if (featGrid) featGrid.style.display = featVisible > 0 ? '' : 'none';
          if (empty) empty.hidden = gridVisible > 0;
        });
      });
    }
    function boot() { document.querySelectorAll('[data-bx-blog]').forEach(initBlog); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bundle-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      document.querySelectorAll('[data-bdl-faq]').forEach(function (root) {
        var items = root.querySelectorAll('[data-bdl-faq-toggle]');
        items.forEach(function (item) {
          function toggle() {
            var isOpen = item.classList.contains('faq__item--open');
            items.forEach(function (i) { i.classList.remove('faq__item--open'); });
            if (!isOpen) item.classList.add('faq__item--open');
          }
          item.addEventListener('click', toggle);
          item.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bundle-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      document.querySelectorAll('[data-bdl-final-cta]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pick = document.getElementById('bundle-pick');
          if (pick) pick.scrollIntoView({ behavior: 'smooth', block: 'start' });
          else window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bundle-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(n) {
      var v = Math.round(Number(n) * 100) / 100;
      return Number.isInteger(v) ? String(v) : v.toFixed(2);
    }
    var ICN = {
      minus: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
      plus: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
      check: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3.5 8.2l3 3 6-6.4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      circle: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5"/></svg>',
      clock: '<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.4"/><path d="M10 6v4l3 2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
      ship: '<svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M1 4.5h8v6.5H1zM9 6.5h2.7l2.3 2.3v2.2H9z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="4" cy="12.5" r="1.4" fill="currentColor"/><circle cx="12" cy="12.5" r="1.4" fill="currentColor"/></svg>'
    };

    function initBundle(root) {
      var cfgEl = root.querySelector('[data-bdl-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

      var ONCE = cfg.onceTiers, SUB = cfg.subTiers, FREE = cfg.freeShipMin;
      var LIST_PER_UNIT = cfg.listShake + cfg.listMetab + cfg.listBloat;
      var TIERS = cfg.tiers || [];
      var SHOTS = cfg.shots || [];

      function tierById(id) {
        for (var i = 0; i < TIERS.length; i++) { if (TIERS[i].id === id) return TIERS[i]; }
        return TIERS[1] || TIERS[0];
      }
      // Flexible Trying-Out price scaling: 1=tier0, 2=tier1, 3=tier2, then +flexStep/box.
      function flexPrice(n, plan) {
        var arr = plan === 'sub' ? SUB : ONCE;
        if (n <= 1) return arr[0];
        if (n === 2) return arr[1];
        if (n === 3) return arr[2];
        return arr[2] + cfg.flexStep * (n - 3);
      }
      function allinTotal(tier, plan, pickedCount) {
        if (tier.flexible) { var n = Math.max(1, pickedCount || tier.units); return flexPrice(n, plan); }
        var i = tier.units - 1;
        return plan === 'sub' ? SUB[i] : ONCE[i];
      }
      function allinList(tier, pickedCount) {
        if (tier.flexible) { var n = Math.max(1, pickedCount || tier.units); return Math.round(LIST_PER_UNIT * n); }
        return cfg.tierStrike[tier.id];
      }

      var state = {
        tierId: null, // no tier selected on load (matches the prototype bundle-app.jsx)
        qty: { vanilla: 0, chocolate: 0 },
        plan: cfg.defaultPlan === 'once' ? 'once' : 'sub',
        freq: 2,
        freqManual: false,
        gallery: 0
      };

      // ── element refs ──────────────────────────────────────────────────────────
      var els = {
        stage: root.querySelector('[data-bdl-stage]'),
        thumbs: root.querySelector('[data-bdl-thumbs]'),
        dots: root.querySelector('[data-bdl-dots]'),
        count: root.querySelector('[data-bdl-count]'),
        tiers: root.querySelector('[data-bdl-tiers]'),
        plans: root.querySelector('[data-bdl-plans]'),
        supply: root.querySelector('[data-bdl-supply]'),
        eta: root.querySelector('[data-bdl-eta]'),
        atc: root.querySelector('[data-bdl-atc]'),
        ship: root.querySelector('[data-bdl-ship]'),
        galleryMain: root.querySelector('[data-bdl-gallery]')
      };

      // ── helpers ────────────────────────────────────────────────────────────────
      function pickedQty() { return (state.qty.vanilla || 0) + (state.qty.chocolate || 0); }
      function liveWeeks(tier) {
        if (tier.flexible) return Math.max(tier.weeks, (pickedQty() || 1) * 2);
        return tier.weeks;
      }
      function businessEta(n) {
        var d = new Date(); var added = 0;
        while (added < n) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
        return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      }

      // ── GALLERY ──────────────────────────────────────────────────────────────
      // Desktop + mobile: a horizontal scroll rail (swipe on touch / drag with a mouse).
      // Desktop caps the rail at 5 thumbs (CSS max-width) and keeps the paging arrows.
      var galleryBuilt = false, railWired = false;
      window.addEventListener('resize', function () { if (galleryBuilt) syncArrows(); });
      function buildGallery() {
        if (!SHOTS.length || !els.stage) return;
        els.stage.innerHTML = SHOTS.map(function (s, i) {
          return '<div class="bdl-shot' + (i === 0 ? ' bdl-shot--on' : '') + '" data-bdl-shot="' + i + '">' +
            '<img src="' + (s.img || '') + '" alt="' + (s.lbl || '') + '"' + (i === 0 ? '' : ' loading="lazy"') + '></div>';
        }).join('');
        els.thumbs.innerHTML = SHOTS.map(function (s, i) {
          return '<button type="button" class="hero-thumbs__btn ' + (i === 0 ? 'hero-thumbs__btn--on' : 'hero-thumbs__btn--off') + '"' +
            ' data-bdl-thumb="' + i + '" style="background:' + (s.bg || '') + '" aria-label="' + (s.lbl || '') + '">' +
            '<img src="' + (s.img || '') + '" alt="" loading="lazy"></button>';
        }).join('');
        els.dots.innerHTML = SHOTS.map(function (_, i) {
          return '<span class="hero-thumbs__dot' + (i === 0 ? ' hero-thumbs__dot--on' : '') + '" data-bdl-dot="' + i + '"></span>';
        }).join('');
        els.thumbs.querySelectorAll('[data-bdl-thumb]').forEach(function (b) {
          b.addEventListener('click', function () { setShot(Number(b.getAttribute('data-bdl-thumb'))); });
          var im = b.querySelector('img');                     // fade each thumb img in once it loads (no popping)
          if (im && !im.complete) { im.classList.add('is-fading'); var on = function () { im.classList.add('is-loaded'); }; im.addEventListener('load', on); im.addEventListener('error', on); }
        });
        els.dots.querySelectorAll('[data-bdl-dot]').forEach(function (d) {
          d.addEventListener('click', function () { setShot(Number(d.getAttribute('data-bdl-dot'))); });
        });
        var rail = root.querySelector('.hero-thumbs');
        if (rail) rail.style.display = SHOTS.length <= 1 ? 'none' : '';
        galleryBuilt = true;
        wireRail();
        setShot(0, true); // init: skip the scrollIntoView (would yank the page to the gallery on load)
        syncArrows();
      }
      // Enable/disable the flanking arrows based on how far the rail is scrolled.
      function syncArrows() {
        if (!els.thumbs) return;
        var tprev = root.querySelector('[data-bdl-thumb-prev]'), tnext = root.querySelector('[data-bdl-thumb-next]');
        var max = els.thumbs.scrollWidth - els.thumbs.clientWidth;
        if (tprev) tprev.disabled = els.thumbs.scrollLeft <= 1;
        if (tnext) tnext.disabled = els.thumbs.scrollLeft >= max - 1;
      }
      function pageBy(dir) {                                     // arrows scroll the rail by one visible page
        if (!els.thumbs) return;
        var bthumbs = els.thumbs.querySelectorAll('[data-bdl-thumb]');
        var step = (bthumbs.length > 1) ? (bthumbs[1].offsetLeft - bthumbs[0].offsetLeft) : 74;
        var per = Math.max(1, Math.round(els.thumbs.clientWidth / step));
        els.thumbs.scrollBy({ left: dir * per * step, behavior: 'smooth' });
      }
      // Scroll sync + desktop mouse drag-to-scroll on the rail (wired once).
      function wireRail() {
        if (railWired || !els.thumbs) return;
        railWired = true;
        var track = els.thumbs;
        track.addEventListener('scroll', syncArrows, { passive: true });
        var down = false, sx = 0, sl = 0, moved = false, pressIdx = -1, ptrType = '', snapRAF = 0;
        function thumbStep() { var t = els.thumbs.querySelectorAll('[data-bdl-thumb]'); return t.length > 1 ? (t[1].offsetLeft - t[0].offsetLeft) : 74; }
        function gentleSnap(target) {                           // ease (decelerate) into the nearest thumb edge
          cancelAnimationFrame(snapRAF);
          var startL = track.scrollLeft, dist = target - startL, t0 = 0;
          if (Math.abs(dist) < 1) { track.classList.remove('is-dragging'); return; }
          function tick(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / 340);
            track.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));   // easeOutCubic
            if (p < 1) { snapRAF = requestAnimationFrame(tick); }
            else { track.classList.remove('is-dragging'); }
          }
          snapRAF = requestAnimationFrame(tick);
        }
        function onMove(e) {
          if (!down) return;
          var dx = e.clientX - sx;
          if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }   // a real drag has begun
          if (moved) track.scrollLeft = sl - dx;
        }
        function endDrag() {
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', endDrag);
          window.removeEventListener('pointercancel', endDrag);
          if (!down) return;
          down = false;
          if (moved) { gentleSnap(Math.round(track.scrollLeft / thumbStep()) * thumbStep()); }
          else { track.classList.remove('is-dragging'); if (pressIdx > -1) setShot(pressIdx); }    // a tap selects the pressed thumb
          pressIdx = -1;
        }
        track.addEventListener('pointerdown', function (e) {
          ptrType = e.pointerType;
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          var b = e.target.closest('[data-bdl-thumb]');
          pressIdx = b ? Number(b.getAttribute('data-bdl-thumb')) : -1;
          down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
          cancelAnimationFrame(snapRAF);                        // grabbing again interrupts an in-flight snap
          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', endDrag);
          window.addEventListener('pointercancel', endDrag);
        });
        // Mouse selection is handled on pointerup (endDrag) — swallow the synthetic mouse click so it
        // neither double-fires nor (after a drag) switches the shot. Touch/keyboard clicks pass through.
        track.addEventListener('click', function (e) { if (ptrType === 'mouse' && e.detail > 0) { e.preventDefault(); e.stopPropagation(); } }, true);
        // Block native image dragging so a drag that starts ON a thumb still scrolls the rail.
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      function setShot(i, skipScroll) {
        if (!SHOTS.length) return;
        var total = SHOTS.length;
        state.gallery = (i + total) % total;
        var shot = SHOTS[state.gallery];
        if (els.galleryMain && shot && shot.bg) els.galleryMain.style.background = shot.bg;
        els.stage.querySelectorAll('[data-bdl-shot]').forEach(function (s, n) { s.classList.toggle('bdl-shot--on', n === state.gallery); });
        var bthumbs = els.thumbs.querySelectorAll('[data-bdl-thumb]');
        bthumbs.forEach(function (b, n) {
          b.classList.toggle('hero-thumbs__btn--on', n === state.gallery);
          b.classList.toggle('hero-thumbs__btn--off', n !== state.gallery);
        });
        if (!skipScroll && bthumbs[state.gallery] && bthumbs[state.gallery].scrollIntoView) { bthumbs[state.gallery].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); }
        els.dots.querySelectorAll('[data-bdl-dot]').forEach(function (d, n) { d.classList.toggle('hero-thumbs__dot--on', n === state.gallery); });
        if (els.count) els.count.textContent = ('0' + (state.gallery + 1)).slice(-2) + ' / ' + ('0' + total).slice(-2);
      }
      function shotIndexForTier(id) {
        for (var i = 0; i < SHOTS.length; i++) { if (SHOTS[i].id === id) return i; }
        return -1;
      }

      // ── TIER ROWS ───────────────────────────────────────────────────────────────
      function renderTiers() {
        // Build the .bdt-row shells ONCE so they persist — toggling metab-qty__opt--on on a live row
        // animates its max-height grow + shadow lift (rebuilding the whole list each time recreated
        // the selected row already expanded, so it popped open instantly). Inner content repaints in
        // place; the tier image is cached so re-setting innerHTML doesn't flash.
        if (!els.tiers.querySelector('.bdt-row')) {
          els.tiers.innerHTML = TIERS.map(function (t) {
            return '<div class="metab-qty__opt bdt-row" role="button" tabindex="0" data-bdl-tier="' + t.id + '" data-bundle-id="' + t.id + '">' +
              '<span class="metab-qty__check" aria-hidden="true"><svg width="11" height="11" viewBox="0 0 16 16" fill="none"><path d="M3.5 8.2l3 3 6-6.4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
              '<span class="bdt-row__chipslot"></span>' +
              '<span class="metab-qty__img-col bdt-row__img"><img src="' + (t.img || '') + '" alt="' + t.label + '" loading="lazy"></span>' +
              '<span class="bdt-row__rest"></span>' +
            '</div>';
          }).join('');
        }
        TIERS.forEach(function (tier) {
          var row = els.tiers.querySelector('[data-bdl-tier="' + tier.id + '"]');
          if (!row) return;
          var selected = tier.id === state.tierId;
          var v = selected ? (state.qty.vanilla || 0) : 0;
          var c = selected ? (state.qty.chocolate || 0) : 0;
          var picked = v + c;
          var target = tier.flexible ? 1 : tier.units;
          var complete = picked >= target;
          var previewCount = tier.flexible ? 1 : tier.units;
          var total = allinTotal(tier, state.plan, previewCount);
          var list = allinList(tier, previewCount);
          var savings = Math.round(list - total);
          var savingsPct = list > 0 ? Math.round((savings / list) * 100) : 0;
          var bottles = tier.flexible ? Math.max(1, picked) : tier.units;

          var shakeStatus = picked === 0
            ? (tier.flexible ? 'Choose at least 1 box' : 'Choose ' + tier.units + ' ' + (tier.units === 1 ? 'box' : 'boxes'))
            : picked + ' / ' + target + ' ' + (target === 1 ? 'box' : 'boxes') + ' selected';
          var shakeStatusShort = picked === 0
            ? (tier.flexible ? 'Choose 1+' : 'Choose ' + tier.units)
            : picked + ' / ' + target + ' selected';

          var chipInline = '', chipMobile = '', chipBest = '';
          if (tier.chip) {
            if (tier.chipColor === 'terracotta') {
              chipBest = '<span class="bdt-row__chip bdt-row__chip--terracotta">' + tier.chip + '</span>';
            } else {
              chipInline = '<span class="bdt-row__chip bdt-row__chip--' + tier.chipColor + ' bdt-row__chip--inline">' + tier.chip + '</span>';
              if (tier.chipColor === 'forest') chipMobile = '<span class="bdt-row__chip bdt-row__chip--forest bdt-row__chip--mobile-bottom">' + tier.chip + '</span>';
            }
          }

          var inner;
          if (selected) {
            var pickHd;
            if (picked === 0) {
              pickHd = '<span class="bdt-row__pick-prompt">' + shakeStatus + '</span>';
            } else {
              var lines = [{ id: 'shake', lbl: shakeStatus, done: complete }, { id: 'supp', lbl: bottles + ' of each supplement bottle', done: true }];
              if (tier.showGifts && tier.giftCount > 0) {
                lines.push({ id: 'gifts', lbl: tier.giftCount + ' free ' + (tier.giftCount === 1 ? 'gift' : 'gifts') + ' ($' + tier.giftValue + ' value)', done: true });
              }
              pickHd = lines.map(function (ln) {
                return '<span class="bdt-row__pick-line ' + (ln.done ? 'bdt-row__pick-line--done' : '') + '">' +
                  '<span class="bdt-row__pick-line-icon" aria-hidden="true">' + (ln.done ? ICN.check : ICN.circle) + '</span><span>' + ln.lbl + '</span></span>';
              }).join('');
            }
            inner =
              '<span class="bdt-row__pick-mobile-prompt">' + (picked === 0 ? shakeStatusShort : (picked + ' / ' + target)) + '</span>' +
              '<span class="bdt-row__pick"><span class="bdt-row__pick-hd">' + pickHd + '</span>' + stepperPair(tier, v, c) + '</span>';
          } else {
            inner =
              '<span class="metab-qty__lbl-col">' +
                '<span class="metab-qty__name">' + tier.label + chipInline + '</span>' +
                '<span class="metab-qty__sub">' + tier.supply + '</span>' + chipMobile +
              '</span>' +
              '<span class="metab-qty__price-col bdt-row__right">' +
                (savings > 0 ? '<span class="bdt-row__price-strike">$' + list + '</span>' : '') +
                '<span class="bdt-row__price-now">$' + total + '</span>' +
                (savings > 0 ? '<span class="bdt-row__save">save $' + savings + ' (' + savingsPct + '%)</span>' : '') +
              '</span>';
          }

          row.classList.toggle('metab-qty__opt--on', selected);
          row.classList.toggle('bdt-row--picking', selected);
          row.setAttribute('aria-pressed', selected);
          // Only the chip slot + dynamic remainder repaint; the check mark and tier
          // image persist so selection never recreates (and flashes) the <img>.
          row.querySelector('.bdt-row__chipslot').innerHTML = selected ? '' : chipBest;
          row.querySelector('.bdt-row__rest').innerHTML = inner;
        });
      }
      function stepperPair(tier, v, c) {
        return '<div class="bdt-stps">' + stepperOne(tier, 'vanilla', 'Vanilla', v) + stepperOne(tier, 'chocolate', 'Chocolate', c) + '</div>';
      }
      function stepperOne(tier, id, label, value) {
        var empty = value <= 0;
        var name = '<span class="bdt-stp__name ' + (empty ? 'bdt-stp__name--tap' : '') + '"' +
          (empty ? ' role="button" tabindex="0" data-bdl-stp-add="' + id + '"' : '') + '>' + label + '</span>';
        var ctrl = '<div class="stepper ' + (empty ? 'stepper--collapsed' : '') + '">' +
          (empty ? '' :
            '<button aria-label="Decrease ' + label + '" data-bdl-stp-dec="' + id + '" class="stepper__btn">' + ICN.minus + '</button>' +
            '<span class="stepper__val">' + value + '</span>') +
          '<button aria-label="' + (empty ? 'Add ' + label : 'Increase ' + label) + '" data-bdl-stp-inc="' + id + '" class="stepper__btn stepper__btn--add">' + ICN.plus + '</button>' +
        '</div>';
        return '<div class="bdt-stp" data-bdl-stp>' + name + ctrl + '</div>';
      }

      // stepper logic — sum constrained to tier.units (swap at cap); flexible = no cap.
      function stpInc(id) {
        var tier = tierById(state.tierId);
        var cap = tier.flexible ? Infinity : tier.units;
        var isV = id === 'vanilla';
        var mine = isV ? (state.qty.vanilla || 0) : (state.qty.chocolate || 0);
        var other = isV ? (state.qty.chocolate || 0) : (state.qty.vanilla || 0);
        if (mine + other < cap) {
          if (isV) state.qty = { vanilla: mine + 1, chocolate: other };
          else state.qty = { vanilla: other, chocolate: mine + 1 };
        } else if (other > 0) {
          if (isV) state.qty = { vanilla: mine + 1, chocolate: other - 1 };
          else state.qty = { vanilla: other - 1, chocolate: mine + 1 };
        } else { return; }
        syncFreq(); render();
      }
      function stpDec(id) {
        var isV = id === 'vanilla';
        var mine = isV ? (state.qty.vanilla || 0) : (state.qty.chocolate || 0);
        if (mine <= 0) return;
        if (isV) state.qty = { vanilla: mine - 1, chocolate: state.qty.chocolate || 0 };
        else state.qty = { vanilla: state.qty.vanilla || 0, chocolate: mine - 1 };
        syncFreq(); render();
      }
      function switchTier(id) {
        state.tierId = id;
        state.qty = { vanilla: 0, chocolate: 0 };
        var idx = shotIndexForTier(id);
        if (idx >= 0) setShot(idx);
        syncFreq(); render();
      }
      function syncFreq() {
        if (state.tierId == null) return;
        // Delivery frequency tracks the LIVE supply, not the tier's base
        // weeks. On the flexible "trying out" tier the supply scales with
        // the number of boxes picked (each box = 2 weeks), so the cadence
        // must follow the item count — a fresh shipment lands just as the
        // previous supply runs out ("matches your X-week supply"). Cap at
        // the largest selectable option (12 weeks); beyond that, extras
        // legitimately build up and the cadence note says so.
        state.freq = Math.min(liveWeeks(tierById(state.tierId)), 12);
        state.freqManual = false;        // qty/tier changed → auto cadence wins again
      }

      // ── PLAN CARDS ──────────────────────────────────────────────────────────────
      function renderPlans() {
        var picked = state.tierId != null;
        var tier = picked ? tierById(state.tierId) : TIERS[0];
        var count = pickedQty() || (tier.flexible ? 1 : tier.units);
        var weeks = liveWeeks(tier);
        var list = allinList(tier, count);
        var sub = allinTotal(tier, 'sub', count);
        var once = allinTotal(tier, 'once', count);
        var days = weeks * 7;
        var subPerDay = (sub / days).toFixed(2);
        var oncePerDay = (once / days).toFixed(2);
        var savings = once - sub;
        var onSub = state.plan === 'sub';

        // Subscribe card
        var freqOpts = [2, 4, 6, 8, 10, 12].map(function (w) {
          return '<option value="' + w + '" ' + (w === state.freq ? 'selected' : '') + '>' + w + ' weeks</option>';
        }).join('');
        var cadence = state.freq === weeks
          ? '≈ matches your ' + weeks + '-week supply'
          : (state.freq < weeks
            ? '≈ extras build up — ' + (weeks - state.freq) + ' wks ahead each shipment'
            : '≈ ' + (state.freq - weeks) + ' wks gap after your supply runs out');

        var subInner =
            '<span class="pln__tag">Save $' + savings + ' · most popular</span>' +
            '<button class="pln__body" type="button" data-bdl-plan-select="sub">' +
              '<span class="pln__radio"></span>' +
              '<span class="bdl-pln-titlecol"><span class="pln__title">Subscribe &amp; save</span>' +
              '<span class="pln__meal pln__meal--hl">$' + subPerDay + ' / day</span></span>' +
              '<span class="pln__pricecol"><span class="pln__pricecol-num pln__pricecol-num--sale">' +
                '<span class="pln__pricecol-strike">$' + list + '</span>$' + sub +
                '<span class="pln__pricecol-unit">/ bundle</span></span></span>' +
            '</button>' +
            (onSub ?
              '<div class="pln__detail"><ul class="pln__perks">' +
                '<li>' + ICN.check + '<span>$' + savings + ' off every order</span></li>' +
                '<li>' + ICN.check + '<span>Skip or reschedule anytime</span></li>' +
                '<li>' + ICN.check + '<span>Cancel anytime — no fees</span></li>' +
              '</ul><div class="pln__freq"><span class="pln__freq-label">' + ICN.clock + ' Delivers every</span>' +
                '<select class="pln__freq-sel" data-bdl-freq aria-label="Delivery frequency">' + freqOpts + '</select>' +
                '<span class="pln__freq-cadence bdl-freq-cadence">' + cadence + '</span></div></div>'
              : '') +
            '<div class="pln__foot bdl-clickable" data-bdl-plan-select="sub"><strong>Skip, swap or cancel — anytime.</strong>' +
            '<span> One click in your account. No phone calls, no hoops.</span></div>';

        // One-time card
        var showStrike = once < list;
        var onceInner =
            '<div class="pln__body"><span class="pln__radio"></span>' +
              '<span class="bdl-pln-titlecol"><span class="pln__title">One-time purchase</span>' +
              '<span class="pln__meal">$' + oncePerDay + ' / day</span></span>' +
              '<span class="pln__pricecol"><span class="pln__pricecol-num ' + (showStrike ? 'pln__pricecol-num--sale' : '') + '">' +
                (showStrike ? '<span class="pln__pricecol-strike">$' + list + '</span>' : '') + '$' + once +
                '<span class="pln__pricecol-unit">/ bundle</span></span></span>' +
            '</div>';

        // Build the two .pln shells ONCE so they persist — toggling pln--on on a live card fades its
        // border/background in (a full innerHTML rebuild mounts the card already-selected, so the
        // .18s transition never fired). Inner content repaints in place.
        if (!els.plans.querySelector('.pln')) {
          els.plans.innerHTML =
            '<div class="pln bdl-clickable" data-bdl-plan="sub" data-bdl-plan-select="sub"></div>' +
            '<button class="pln bdl-pln-once-btn" type="button" data-bdl-plan="once" data-bdl-plan-select="once"></button>';
        }
        var subEl = els.plans.querySelector('[data-bdl-plan="sub"]');
        var onceEl = els.plans.querySelector('[data-bdl-plan="once"]');
        if (subEl) { subEl.classList.toggle('pln--on', onSub); subEl.innerHTML = subInner; }
        if (onceEl) { onceEl.classList.toggle('pln--on', !onSub); onceEl.innerHTML = onceInner; }
        els.supply.textContent = weeks + '-WEEK SUPPLY';
      }

      // ── SHIP BAR (ms-twin ship-only) ───────────────────────────────────────────
      function renderShip(subtotal) {
        var pct = Math.min(100, (subtotal / FREE) * 100);
        var on = subtotal >= FREE;
        els.ship.innerHTML = '<div class="ms-twin ms-twin--ship-only"><div class="ms-twin__bar ms-twin__bar--tall" style="--ms-pct:' + pct + '%">' +
          '<div class="ms-twin__fill ' + (pct >= 100 ? 'ms-twin__fill--full' : '') + '" style="width:' + pct + '%;background:var(--forest)"></div>' +
          '<span class="ms-twin__inside ' + (on ? 'ms-twin__inside--on' : '') + '"><span class="ms-twin__inside-icon">' + ICN.ship + '</span>' +
          (on ? 'Free shipping unlocked' : 'Add $' + Math.ceil(FREE - subtotal) + ' for free shipping') + '</span>' +
          '<span class="ms-twin__dot" style="left:100%;' + (on ? 'background:var(--forest);border-color:var(--forest);' : 'background:var(--cream-2);border-color:var(--cream-2);') + '"></span></div></div>';
      }

      // ── CTA + ETA ────────────────────────────────────────────────────────────────
      function renderCta() {
        var picked = state.tierId != null;
        var tier = picked ? tierById(state.tierId) : TIERS[0];
        var pq = pickedQty();
        var complete = picked && (tier.flexible ? pq >= 1 : pq === tier.units);
        var remaining = picked && !tier.flexible ? tier.units - pq : 0;
        var total = picked ? allinTotal(tier, state.plan, pq || (tier.flexible ? 1 : tier.units)) : null;
        var list = picked ? allinList(tier, pq || (tier.flexible ? 1 : tier.units)) : null;
        var savings = picked ? Math.round(list - total) : 0;

        if (complete) {
          els.atc.className = 'btn btn--lg btn--block btn--primary bdl-atc';
          els.atc.disabled = false;
          els.atc.innerHTML =
            '<span class="bdl-flex-left">Add bundle · ' + tier.supply.toLowerCase() + '</span>' +
            '<span class="bdl-atc-pricegrp">' +
            (savings > 0 ? '<span class="bdl-atc-strike">$' + list + '</span>' : '') +
            '<span class="bdl-atc-total">$' + total + '</span></span>';
        } else {
          els.atc.className = 'btn btn--lg btn--block btn--disabled bdl-atc';
          els.atc.disabled = true;
          var msg = !picked ? 'Pick a bundle to continue'
            : (tier.flexible ? 'Pick at least 1 shake box'
              : 'Pick ' + remaining + ' more shake ' + (remaining === 1 ? 'box' : 'boxes'));
          els.atc.innerHTML = '<span class="bdl-flex-center">' + msg + '</span>';
        }

        // ETA
        var etaStr = businessEta(3);
        els.eta.innerHTML = state.plan === 'sub'
          ? '1st delivery <strong class="bdl-eta-strong">' + etaStr + '</strong> then every ' + state.freq + ' weeks'
          : 'Estimated delivery: <strong class="bdl-eta-strong">' + etaStr + '</strong>';

        renderShip(picked ? total : 0);
      }

      function render() {
        renderTiers();
        renderPlans();
        renderCta();
      }

      // ── ADD TO CART ────────────────────────────────────────────────────────────
      // Mirror the prototype: a picked tier commits its flavor split. We add the
      // bundle product's matching flavor variant with quantity = unit count
      // (flexible tier scales with the boxes the shopper picked). Plan/freq/tier
      // ride along as line-item properties.
      function commitAdd() {
        if (state.tierId == null) return;
        var tier = tierById(state.tierId);
        var v = state.qty.vanilla || 0;
        var c = state.qty.chocolate || 0;
        var boxes = v + c;
        var complete = tier.flexible ? boxes >= 1 : boxes === tier.units;
        if (!complete) return;

        var props = { _plan: state.plan, _bundle_tier: tier.label, _supply: tier.supply };
        if (state.plan === 'sub') props._delivery_weeks = String(state.freq);
        // Carry the selling plan ourselves — do NOT rely on the drawer to attach it. The drawer
        // only plans lines whose variant it has an alias for, and its bundle alias is a single id
        // (the product's first available variant = Chocolate). Vanilla Caramel therefore fell
        // through its queueAdd "foreign item" path and was added as a ONE-TIME line: the shopper
        // was charged $149 instead of $119 and silently got no subscription — and because the
        // bundle volume rules are subscription-only with a 2+/3+ minimum, a mixed cart dropped
        // below the minimum and lost the volume discount on BOTH lines too (1 choc + 1 vanilla
        // billed $268 against the advertised $189). queueAdd posts queued items verbatim, so the
        // plan set here survives. Chocolate still gets the same id from the drawer's own planFor,
        // so the two flavors stay on one plan and no drift rewrite fires.
        var sp = state.plan === 'sub' ? ((cfg.plans || {})[String(state.freq)] || null) : null;
        var items = [];
        if (c > 0 && cfg.variants.chocolate) {
          var ic = { id: cfg.variants.chocolate, quantity: c, properties: props };
          if (sp) ic.selling_plan = sp;
          items.push(ic);
        }
        if (v > 0 && cfg.variants.vanilla) {
          var iv = { id: cfg.variants.vanilla, quantity: v, properties: props };
          if (sp) iv.selling_plan = sp;
          items.push(iv);
        }
        if (!items.length) return;

        els.atc.disabled = true;
        if (window.BiomeCart && window.BiomeCart.addAndOpen) {
          window.BiomeCart.addAndOpen(items, { plan: state.plan, freq: state.freq, freqManual: state.freqManual })
            .then(function () { els.atc.disabled = false; })
            .catch(function () { els.atc.disabled = false; });
        } else {
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { window.location.href = '/cart'; })
            .catch(function () { els.atc.disabled = false; });
        }
      }

      // ── EVENTS (delegated on the section root) ──────────────────────────────────
      root.addEventListener('click', function (e) {
        var stpAdd = e.target.closest('[data-bdl-stp-add]'); if (stpAdd) { e.stopPropagation(); stpInc(stpAdd.getAttribute('data-bdl-stp-add')); return; }
        var stpInc2 = e.target.closest('[data-bdl-stp-inc]'); if (stpInc2) { e.stopPropagation(); stpInc(stpInc2.getAttribute('data-bdl-stp-inc')); return; }
        var stpDec2 = e.target.closest('[data-bdl-stp-dec]'); if (stpDec2) { e.stopPropagation(); stpDec(stpDec2.getAttribute('data-bdl-stp-dec')); return; }
        // A click inside a flavor stepper (e.g. the flavor name once it has a quantity) must not
        // bubble to the tier row's handler and reset the selection — only the +/- buttons change qty.
        if (e.target.closest('[data-bdl-stp]')) return;
        // Frequency <select> still opens without re-selecting the plan.
        if (e.target.closest('select, input, option, [data-bdl-freq]')) return;
        var planSel = e.target.closest('[data-bdl-plan-select]'); if (planSel) { e.stopPropagation(); state.plan = planSel.getAttribute('data-bdl-plan-select'); render(); return; }
        var tierBtn = e.target.closest('[data-bdl-tier]'); if (tierBtn) { switchTier(tierBtn.getAttribute('data-bdl-tier')); return; }
        var tprev = e.target.closest('[data-bdl-thumb-prev]'); if (tprev) { pageBy(-1); return; }
        var tnext = e.target.closest('[data-bdl-thumb-next]'); if (tnext) { pageBy(1); return; }
        var prev = e.target.closest('[data-bdl-prev]'); if (prev) { setShot(state.gallery - 1); return; }
        var next = e.target.closest('[data-bdl-next]'); if (next) { setShot(state.gallery + 1); return; }
        var atc = e.target.closest('[data-bdl-atc]'); if (atc) { commitAdd(); return; }
      });
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var stpKey = e.target.closest('[data-bdl-stp-add]');
        if (stpKey) { e.preventDefault(); e.stopPropagation(); stpInc(stpKey.getAttribute('data-bdl-stp-add')); return; }
        var tierKey = e.target.closest('[data-bdl-tier]');
        if (tierKey) { e.preventDefault(); switchTier(tierKey.getAttribute('data-bdl-tier')); return; }
      });
      root.addEventListener('change', function (e) {
        var f = e.target.closest('[data-bdl-freq]');
        if (f) { state.freq = Number(f.value); state.freqManual = true; render(); }
      });

      // swipe support on the main gallery image
      if (els.galleryMain) {
        var touch = { x: 0, t: 0 };
        els.galleryMain.addEventListener('touchstart', function (e) { touch = { x: e.touches[0].clientX, t: Date.now() }; }, { passive: true });
        els.galleryMain.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - touch.x;
          var dt = Date.now() - touch.t;
          if (Math.abs(dx) > 40 && dt < 600) setShot(state.gallery + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }

      // Allow review cards (elsewhere on the page) to jump to a tier:
      // window.BiomeBundle.pickTier('habits')
      window.BiomeBundle = {
        pickTier: function (id) {
          switchTier(id);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setTimeout(function () {
            var el = root.querySelector('[data-bundle-id="' + id + '"]');
            if (el) { el.classList.add('bdl-card--flash'); setTimeout(function () { el.classList.remove('bdl-card--flash'); }, 2000); }
          }, 500);
        }
      };

      buildGallery();
      // apply default tier from settings (optional)
      if (cfg.defaultTier) { /* leave unselected on load to match the prototype */ }
      render();
    }

    function boot() { document.querySelectorAll('[data-biome-bundle]').forEach(initBundle); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bundle-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      document.querySelectorAll('[data-bdl-reviews] [data-bdl-pick-tier]').forEach(function (card) {
        function pick() {
          var id = card.getAttribute('data-bdl-pick-tier');
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setTimeout(function () {
            var el = document.querySelector('[data-bundle-id="' + id + '"]');
            if (!el) return;
            el.classList.add('bdl-card--flash');
            setTimeout(function () { el.classList.remove('bdl-card--flash'); }, 2000);
          }, 600);
        }
        card.addEventListener('click', pick);
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-bundle-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function f(n) { return (Math.round(n * 100) / 100).toFixed(2); }
    function smoothPath(pts) {
      if (pts.length < 2) return '';
      var d = 'M' + f(pts[0][0]) + ',' + f(pts[0][1]);
      for (var i = 0; i < pts.length - 1; i++) {
        var p0 = pts[i - 1] || pts[i];
        var p1 = pts[i];
        var p2 = pts[i + 1];
        var p3 = pts[i + 2] || p2;
        var c1x = p1[0] + (p2[0] - p0[0]) / 6;
        var c1y = p1[1] + (p2[1] - p0[1]) / 6;
        var c2x = p2[0] - (p3[0] - p1[0]) / 6;
        var c2y = p2[1] - (p3[1] - p1[1]) / 6;
        d += ' C' + f(c1x) + ',' + f(c1y) + ' ' + f(c2x) + ',' + f(c2y) + ' ' + f(p2[0]) + ',' + f(p2[1]);
      }
      return d;
    }
    function parseNums(s) {
      return (s || '').split(',').map(function (x) { return parseFloat(x.trim()); }).filter(function (x) { return !isNaN(x); });
    }
    function drawChart(svg) {
      var data = parseNums(svg.getAttribute('data-data'));
      var highlight = parseNums(svg.getAttribute('data-highlight'));
      var max = parseFloat(svg.getAttribute('data-max')) || 75;
      var accent = svg.getAttribute('data-accent') || '#C4623C';
      var finalLabel = svg.getAttribute('data-final') || '';
      var inverted = svg.getAttribute('data-inverted') === 'true';
      if (!data.length) return;

      var w = 300, h = 88, padX = 14, padTop = 18, padBottom = 22;
      var innerW = w - padX * 2;
      var innerH = h - padTop - padBottom;
      var xFor = function (wk) { return padX + (wk / 12) * innerW; };
      var baselineY = inverted ? padTop + innerH * 0.22 : padTop + innerH;
      var unitDown = inverted ? (innerH * 0.78) / max : innerH / max;
      var unitUp = inverted ? (innerH * 0.22) / max : innerH / max;
      var yFor = function (v) {
        if (inverted) return v >= 0 ? baselineY + v * unitDown : baselineY + v * unitUp;
        return baselineY - v * unitDown;
      };
      var points = data.map(function (v, i) { return [xFor(i), yFor(v)]; });
      var pathD = smoothPath(points);
      var hx1 = xFor(highlight[0]);
      var hx2 = xFor(highlight[1]);
      var last = points[points.length - 1];
      var NS = 'http://www.w3.org/2000/svg';

      function el(name, attrs) {
        var e = document.createElementNS(NS, name);
        for (var k in attrs) { if (attrs.hasOwnProperty(k)) e.setAttribute(k, attrs[k]); }
        return e;
      }

      svg.appendChild(el('rect', { x: hx1, y: padTop - 4, width: hx2 - hx1, height: innerH + 8, fill: accent, opacity: '0.14', rx: '2' }));
      svg.appendChild(el('line', { x1: padX, x2: w - padX, y1: baselineY, y2: baselineY, stroke: 'rgba(245,240,230,0.32)', 'stroke-dasharray': '2 4', 'stroke-width': '1' }));
      svg.appendChild(el('path', { d: pathD, fill: 'none', stroke: accent, 'stroke-width': '1.8', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }));

      points.forEach(function (pt, i) {
        var inHL = i >= highlight[0] && i <= highlight[1];
        var isLast = i === points.length - 1;
        if (isLast) return;
        var delay = (i / (points.length - 1)) * 3.4;
        var c = el('circle', {
          cx: pt[0], cy: pt[1], r: inHL ? 3 : 1.6,
          fill: inHL ? accent : 'rgba(245,240,230,0.5)',
          class: inHL ? 'tl-chart__dot tl-chart__dot--hl' : 'tl-chart__dot'
        });
        c.style.animationDelay = delay.toFixed(2) + 's';
        svg.appendChild(c);
      });
      if (last) svg.appendChild(el('circle', { cx: last[0], cy: last[1], r: 4, fill: accent }));
      if (finalLabel) {
        var t = el('text', { x: w - padX - 5, y: padTop + 28, fill: accent, 'font-size': '13', 'font-family': 'var(--sans)', 'font-weight': '700', 'letter-spacing': '-0.01em', 'text-anchor': 'end' });
        t.textContent = finalLabel;
        svg.appendChild(t);
      }
      var t0 = el('text', { x: padX, y: h - 4, fill: 'rgba(245,240,230,0.4)', 'font-size': '9', 'font-family': 'var(--mono)', 'letter-spacing': '0.08em' });
      t0.textContent = 'WK 0';
      svg.appendChild(t0);
      var t12 = el('text', { x: w - padX, y: h - 4, fill: 'rgba(245,240,230,0.4)', 'font-size': '9', 'font-family': 'var(--mono)', 'text-anchor': 'end', 'letter-spacing': '0.08em' });
      t12.textContent = 'WK 12';
      svg.appendChild(t12);
    }
    function boot() {
      document.querySelectorAll('[data-bdl-tl] [data-bdl-chart]').forEach(drawChart);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-coa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-coa-root]');
    if (!root) return;
    var cfgEl = root.querySelector('[data-coa-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var W = cfg.map.W, latTop = 82, latBot = -58;
    function proj(lng, lat) { return [(lng + 180) / 360 * W, (latTop - lat) / (latTop - latBot) * cfg.map.H]; }
    var origins = cfg.origins, dots = cfg.dots;
    var hub = origins.filter(function (o) { return o.hub; })[0];
    if (!hub) return;
    var hubP = proj(hub.coord[0], hub.coord[1]);
    var svg = root.querySelector('[data-coa-svg]');
    var ledger = root.querySelector('[data-coa-ledger]');
    if (!svg || !ledger) return;

    var dotsHTML = '<g class="coa-map-dots">';
    for (var i = 0; i < dots.length; i++) dotsHTML += '<circle cx="' + dots[i][0] + '" cy="' + dots[i][1] + '" r="2.1"></circle>';
    dotsHTML += '</g>';

    var arcsHTML = '<g class="coa-map-arcs">';
    origins.forEach(function (o) {
      if (o.hub) return;
      var p = proj(o.coord[0], o.coord[1]);
      var mx = (p[0] + hubP[0]) / 2;
      var my = (p[1] + hubP[1]) / 2 - Math.abs(p[0] - hubP[0]) * 0.22 - 18;
      arcsHTML += '<path id="coa-arc-' + o.id + '" class="coa-arc" d="M' + p[0] + ',' + p[1] + ' Q' + mx + ',' + my + ' ' + hubP[0] + ',' + hubP[1] + '"></path>';
    });
    arcsHTML += '</g>';

    var flowHTML = '<circle class="coa-flow" r="3" cx="' + hubP[0] + '" cy="' + hubP[1] + '" style="opacity:0"></circle>';

    var pinsHTML = '<g class="coa-map-pins">';
    origins.forEach(function (o) {
      var p = proj(o.coord[0], o.coord[1]);
      if (o.hub) {
        pinsHTML += '<g class="coa-pin coa-pin--hub" data-coa-pin="' + o.id + '" transform="translate(' + p[0] + ',' + p[1] + ')"><circle class="coa-pin__pulse" r="14"></circle><circle class="coa-pin__core" r="7"></circle><circle class="coa-pin__dot" r="3"></circle></g>';
      } else {
        pinsHTML += '<g class="coa-pin" data-coa-pin="' + o.id + '" transform="translate(' + p[0] + ',' + p[1] + ')"><circle class="coa-pin__halo" r="11"></circle><circle class="coa-pin__core" r="5"></circle></g>';
      }
    });
    pinsHTML += '</g>';
    svg.innerHTML = dotsHTML + arcsHTML + flowHTML + pinsHTML;

    ledger.innerHTML = origins.map(function (o) {
      return '<button type="button" class="coa-led' + (o.hub ? ' coa-led--hub' : '') + '" data-coa-led="' + o.id + '">' +
        '<span class="coa-led__top"><span class="coa-led__place">' + o.place + '</span><span class="coa-led__region">' + o.region + '</span></span>' +
        '<span class="coa-led__ings">' + o.ingredients.map(function (ing) { return '<span class="coa-led__ing">' + ing + '</span>'; }).join('') + '</span>' +
        '<span class="coa-led__why">' + o.why + '</span></button>';
    }).join('');

    var pins = svg.querySelectorAll('[data-coa-pin]');
    var leds = ledger.querySelectorAll('[data-coa-led]');
    function setActive(id) {
      pins.forEach(function (g) {
        var on = g.getAttribute('data-coa-pin') === id;
        if (!g.classList.contains('coa-pin--hub')) g.classList.toggle('coa-pin--on', on);
      });
      svg.querySelectorAll('.coa-arc').forEach(function (a) { a.classList.remove('coa-arc--on'); });
      if (id) { var arc = svg.querySelector('#coa-arc-' + id); if (arc) arc.classList.add('coa-arc--on'); }
      leds.forEach(function (b) { b.classList.toggle('coa-led--on', b.getAttribute('data-coa-led') === id); });
    }
    pins.forEach(function (g) {
      var id = g.getAttribute('data-coa-pin');
      g.addEventListener('mouseenter', function () { setActive(id); });
      g.addEventListener('mouseleave', function () { setActive(null); });
    });
    leds.forEach(function (b) {
      var id = b.getAttribute('data-coa-led');
      b.addEventListener('mouseenter', function () { setActive(id); });
      b.addEventListener('mouseleave', function () { setActive(null); });
      b.addEventListener('focus', function () { setActive(id); });
      b.addEventListener('blur', function () { setActive(null); });
    });

    var flowEl = svg.querySelector('.coa-flow');
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!(mq && mq.matches)) {
      var ids = origins.filter(function (o) { return !o.hub; }).map(function (o) { return 'coa-arc-' + o.id; });
      if (ids.length) {
        var raf, idx = 0, t0 = null, phase = 'move', DUR = 1400, GAP = 300;
        var tick = function (ts) {
          var path = document.getElementById(ids[idx]);
          if (!flowEl || !path) { raf = requestAnimationFrame(tick); return; }
          if (t0 === null) t0 = ts;
          var el = ts - t0;
          if (phase === 'move') {
            var t = Math.min(el / DUR, 1);
            var pt = path.getPointAtLength(t * path.getTotalLength());
            flowEl.setAttribute('cx', pt.x); flowEl.setAttribute('cy', pt.y);
            var fade = t < 0.08 ? t / 0.08 : (t > 0.88 ? Math.max(0, (1 - t) / 0.12) : 1);
            flowEl.style.opacity = String(fade);
            if (t >= 1) { phase = 'gap'; t0 = ts; }
          } else {
            flowEl.style.opacity = '0';
            if (el >= GAP) { phase = 'move'; t0 = ts; idx = (idx + 1) % ids.length; }
          }
          raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-contact-faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initContactFaqs(root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-contact-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-contact-panel]'));

      function selectTab(idx) {
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-contact-tab') === String(idx);
          tab.classList.toggle('contact-tab--on', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-contact-panel') === String(idx);
          panel.hidden = !on;
          if (on) {
            // Reset accordion to first-open whenever a tab becomes active
            // (mirrors the prototype's setOpenIdx(0) on tab change).
            var items = panel.querySelectorAll('[data-contact-faq]');
            items.forEach(function (it, i) {
              it.classList.toggle('faq__item--open', i === 0);
            });
          }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          selectTab(tab.getAttribute('data-contact-tab'));
        });
      });

      // Single-open accordion within each panel
      function toggleItem(item) {
        var panel = item.closest('[data-contact-panel]');
        if (!panel) return;
        var isOpen = item.classList.contains('faq__item--open');
        var items = panel.querySelectorAll('[data-contact-faq]');
        items.forEach(function (el) { el.classList.remove('faq__item--open'); });
        if (!isOpen) item.classList.add('faq__item--open');
      }

      root.querySelectorAll('[data-contact-faq]').forEach(function (item) {
        item.addEventListener('click', function () { toggleItem(item); });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleItem(item);
          }
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-bs-contact-faqs]').forEach(initContactFaqs);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      var items = root.querySelectorAll('.faq__item');
      function toggle(item) {
        if (item.hasAttribute('data-bx-nutrition')) return; // future nutrition panel hooks this
        var isOpen = item.classList.contains('faq__item--open');
        items.forEach(function (el) { el.classList.remove('faq__item--open'); });
        if (!isOpen) item.classList.add('faq__item--open');
      }
      items.forEach(function (item) {
        item.addEventListener('click', function () { toggle(item); });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle(item);
          }
        });
      });
    }
    function boot() {
      document.querySelectorAll('[data-bs-faq]').forEach(initFaq);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-giftcard"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ceilWhole(n) { return Math.ceil(Number(n) || 0); }
    function initGiftCard(root) {
      var denoms = Array.prototype.slice.call(root.querySelectorAll('[data-gc-denom]'));
      var qtyEl = root.querySelector('[data-gc-qty]');
      var eachEl = root.querySelector('[data-gc-each]');
      var totalEl = root.querySelector('[data-gc-total]');
      var atcPriceEl = root.querySelector('[data-gc-atc-price]');
      var atcLblEl = root.querySelector('[data-gc-atc-lbl]');
      var atcBtn = root.querySelector('[data-gc-atc]');

      var state = { variantId: null, amount: 0, qty: 1 };
      var first = denoms.filter(function (d) { return !d.hasAttribute('data-soldout'); })[0] || denoms[0];
      if (first) { state.variantId = first.getAttribute('data-variant-id'); state.amount = Number(first.getAttribute('data-amount')) || 0; }

      // Prices round UP to a whole dollar (product-page ATC convention).
      function paint() {
        var line = ceilWhole(state.amount * state.qty);
        if (totalEl) totalEl.textContent = '$' + line;
        if (atcPriceEl) atcPriceEl.textContent = '$' + line;
        if (atcLblEl) atcLblEl.textContent = state.qty > 1 ? 'Add ' + state.qty + ' cards' : 'Add to cart';
        if (eachEl) {
          if (state.qty > 1) { eachEl.hidden = false; eachEl.textContent = '$' + ceilWhole(state.amount) + ' each'; }
          else { eachEl.hidden = true; }
        }
        if (qtyEl) qtyEl.textContent = state.qty;
      }

      denoms.forEach(function (d) {
        d.addEventListener('click', function () {
          if (d.hasAttribute('data-soldout')) return;
          denoms.forEach(function (x) { x.classList.toggle('gc-denom--on', x === d); x.setAttribute('aria-pressed', x === d ? 'true' : 'false'); });
          state.variantId = d.getAttribute('data-variant-id');
          state.amount = Number(d.getAttribute('data-amount')) || 0;
          paint();
        });
      });
      var dec = root.querySelector('[data-gc-qty-dec]'), inc = root.querySelector('[data-gc-qty-inc]');
      if (dec) dec.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); paint(); });
      if (inc) inc.addEventListener('click', function () { state.qty = Math.min(99, state.qty + 1); paint(); });

      // ── gallery: crossfade stage + thumbnail row + arrows + swipe ──
      var shots = Array.prototype.slice.call(root.querySelectorAll('[data-gc-shot]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gc-thumb]'));
      var gi = 0;
      function setShot(i) {
        if (!shots.length) return;
        gi = (i + shots.length) % shots.length;
        shots.forEach(function (s, n) { s.classList.toggle('gc-stage__img--on', n === gi); });
        thumbs.forEach(function (b, n) { b.classList.toggle('gc-thumb--on', n === gi); });
      }
      thumbs.forEach(function (b, n) { b.addEventListener('click', function () { setShot(n); }); });
      var gp = root.querySelector('[data-gc-prev]'), gn = root.querySelector('[data-gc-next]');
      if (gp) gp.addEventListener('click', function () { setShot(gi - 1); });
      if (gn) gn.addEventListener('click', function () { setShot(gi + 1); });
      var stage = root.querySelector('.gc-stage');
      if (stage && shots.length > 1) {
        var sx = 0, sy = 0, st = 0;
        stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) < 36 || Math.abs(dx) <= Math.abs(dy) || Date.now() - st > 800) return;
          setShot(gi + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }

      // ── details accordion ──
      root.querySelectorAll('[data-gc-acc]').forEach(function (acc) {
        var head = acc.querySelector('[data-gc-acc-head]');
        if (head) head.addEventListener('click', function () {
          var open = acc.classList.toggle('gc-acc--open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      // ── ATC → add, then open the drawer ──
      // A gift card is a "foreign" cart line (not one of the drawer's managed SKUs), so the
      // drawer can't render it optimistically. Add it first and refresh the engine, THEN open —
      // otherwise the sidebar flashes an empty cart before the card syncs in.
      if (atcBtn) atcBtn.addEventListener('click', function () {
        if (!state.variantId) return;
        atcBtn.disabled = true;
        var reset = function () { atcBtn.disabled = false; };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(state.variantId), quantity: state.qty }] })
        }).then(function () {
          if (!window.BiomeCart) return;
          return Promise.resolve(window.BiomeCart.refresh && window.BiomeCart.refresh()).then(function () {
            if (window.BiomeCart.open) window.BiomeCart.open();
          });
        }).then(reset, reset);
      });

      paint();
      setShot(0);
    }
    function boot() { document.querySelectorAll('[data-biome-giftcard]').forEach(initGiftCard); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-header"]) return;
  try {
    
  (function () {
    function initMenu() {
      var mm = document.querySelector('[data-biome-mm]');
      if (!mm) return;
      var back = document.querySelector('.nav-mm__back');
      var openers = document.querySelectorAll('[data-biome-menu-open]');
      var closers = document.querySelectorAll('[data-biome-menu-close]');
      var prevOverflow = '';

      function open() {
        mm.classList.add('nav-mm--open');
        mm.setAttribute('aria-hidden', 'false');
        if (back) { back.classList.add('nav-mm__back--open'); back.setAttribute('aria-hidden', 'false'); }
        openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      function close() {
        mm.classList.remove('nav-mm--open');
        mm.setAttribute('aria-hidden', 'true');
        if (back) { back.classList.remove('nav-mm__back--open'); back.setAttribute('aria-hidden', 'true'); }
        openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        document.body.style.overflow = prevOverflow;
      }

      openers.forEach(function (b) { b.addEventListener('click', open); });
      closers.forEach(function (b) { b.addEventListener('click', close); });
      mm.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    // Compact-on-scroll nav (product pages). Hysteresis — engage at 420, release
    // at 320 — avoids boundary jitter. The promo collapse, height shrink and link
    // fade are all CSS off the .nav--compact class; here we just toggle it and
    // surface the smart ATC (whose price is filled by the buy-box section).
    function initCompactNav() {
      var nav = document.querySelector('[data-biome-nav]');
      var smartAtc = document.querySelector('[data-bx-navatc]');
      if (!nav || !smartAtc) return;
      var compact = false;
      function onScroll() {
        var y = window.scrollY || window.pageYOffset || 0;
        if (!compact && y > 420) {
          compact = true; nav.classList.add('nav--compact');
          smartAtc.setAttribute('aria-hidden', 'false'); smartAtc.tabIndex = 0;
        } else if (compact && y < 320) {
          compact = false; nav.classList.remove('nav--compact');
          smartAtc.setAttribute('aria-hidden', 'true'); smartAtc.tabIndex = -1;
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      smartAtc.addEventListener('click', function () {
        var heroAtc = document.querySelector('[data-bx-atc]');
        if (heroAtc && !heroAtc.disabled) { heroAtc.click(); }
        else { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      });
    }

    initMenu();
    initCompactNav();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-ingredient"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var dataEl = root.querySelector('[data-ind-next-data]');
      var card = root.querySelector('[data-ind-next-card]');
      if (!dataEl || !card) return;
      var items;
      try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!items || !items.length) return;
      var cur = root.getAttribute('data-current');
      var idx = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].h === cur) { idx = i; break; }
      }
      // Next in list (wraps); if current isn't found, falls to the first entry.
      var next = items[(idx + 1) % items.length];
      card.setAttribute('href', '/pages/' + next.h);
      var nameEl = card.querySelector('[data-ind-next-name]');
      var monoEl = card.querySelector('[data-ind-next-mono]');
      if (nameEl) nameEl.textContent = next.n;
      if (monoEl) monoEl.textContent = next.n.replace(/[^A-Za-z]/g, '').slice(0, 1).toUpperCase();
      var imgEl = card.querySelector('[data-ind-next-img]');
      if (imgEl) {
        if (next.img) {
          imgEl.onerror = function () { imgEl.hidden = true; }; // fall back to monogram
          imgEl.alt = next.n;
          imgEl.src = next.img;
          imgEl.hidden = false;
        } else {
          imgEl.hidden = true;
        }
      }
    }
    document.querySelectorAll('[data-ind-next]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-ingredients-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIng(root) {
      var pills = root.querySelectorAll('[data-bs-pill]');
      var panels = root.querySelectorAll('[data-bs-panel]');
      function activate(id) {
        pills.forEach(function (p) {
          var on = p.getAttribute('data-bs-pill') === id;
          if (on) {
            p.setAttribute('data-on', 'true');
            p.style.borderColor = 'var(--forest)';
            p.style.background = 'var(--forest)';
            p.style.color = 'var(--cream)';
          } else {
            p.removeAttribute('data-on');
            p.style.borderColor = 'var(--line)';
            p.style.background = 'var(--paper)';
            p.style.color = 'var(--ink-2)';
          }
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-bs-panel') === id;
          panel.classList.toggle('is-active', on);
          panel.style.display = on ? 'grid' : 'none';
          // restart the fade animation on switch (matches React's key remount)
          if (on) {
            panel.classList.remove('ing-fade');
            void panel.offsetWidth;
            panel.classList.add('ing-fade');
          }
        });
      }
      pills.forEach(function (p) {
        p.addEventListener('click', function () { activate(p.getAttribute('data-bs-pill')); });
      });
      activate('greens');
    }
    function boot() { document.querySelectorAll('[data-bs-ing]').forEach(initIng); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-ingredients-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var dataEl = root.querySelector('[data-ing-data]');
      var tabsEl = root.querySelector('[data-ing-tabs]');
      var gridEl = root.querySelector('[data-ing-grid-list]');
      if (!dataEl || !tabsEl || !gridEl) return;
      var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var TABS = data.tabs, ITEMS = data.items;
      var active = 'bundle';

      function matches(tab, it) { return tab.all || it.p.indexOf(tab.id) !== -1; }
      function count(tab) { var n = 0; ITEMS.forEach(function (it) { if (matches(tab, it)) n++; }); return n; }
      function slug(name) { return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

      function renderTabs() {
        tabsEl.innerHTML = TABS.map(function (t) {
          var on = t.id === active ? ' ing-tab--on' : '';
          return '<button type="button" role="tab" aria-selected="' + (t.id === active) + '" class="ing-tab ing-tab--' + t.color + on + '" data-ing-tab="' + t.id + '">' +
            t.lbl + ' <span class="ing-tab__n">(' + count(t) + ')</span></button>';
        }).join('');
      }
      function renderGrid() {
        var tab = TABS.filter(function (t) { return t.id === active; })[0] || TABS[0];
        var html = '';
        ITEMS.forEach(function (it) {
          if (!matches(tab, it)) return;
          var s = (typeof it.sat === 'number') ? it.sat : 22;
          var bg = s === 0 ? 'hsl(0,0%,90%)' : 'hsl(' + it.hue + ',' + s + '%,85%)';
          var fg = s === 0 ? 'hsl(0,0%,38%)' : 'hsl(' + it.hue + ',' + Math.max(0, s - 6) + '%,32%)';
          var initial = it.name.replace(/[^A-Za-z]/g, '').slice(0, 1).toUpperCase();
          var tile = '<span class="ing-tile" style="--tile-bg:' + bg + ';--tile-fg:' + fg + '">' +
            '<span class="ing-tile__mono">' + initial + '</span>' +
            (it.img && it.img.length ? '<img class="ing-tile__photo" src="' + it.img + '" alt="" loading="lazy">' : '') +
            '</span>';
          html += '<a href="/pages/' + (it.handle || slug(it.name)) + '" class="ing-card">' +
            tile +
            '<span class="ing-card__name">' + it.name + '</span>' +
            (it.b ? '<span class="ing-card__benefit">' + it.b + '</span>' : '') +
            '</a>';
        });
        gridEl.innerHTML = html;
        // Any photo that fails to load (a missing/renamed Files image) is removed,
        // revealing the hue-tinted monogram tile underneath — graceful fallback.
        gridEl.querySelectorAll('.ing-tile__photo').forEach(function (img) {
          img.addEventListener('error', function () { img.remove(); });
        });
      }

      tabsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ing-tab]');
        if (!btn) return;
        active = btn.getAttribute('data-ing-tab');
        renderTabs(); renderGrid();
      });

      renderTabs(); renderGrid();
    }
    document.querySelectorAll('[data-ing-grid]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-metab-duo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var cfgEl = root.querySelector('[data-bx-duo-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      var buy = root.querySelector('[data-bx-duo-buy]');
      var pick = root.querySelector('[data-bx-duo-pick]');
      var addBtn = root.querySelector('[data-bx-duo-add]');
      var backBtn = root.querySelector('[data-bx-duo-back]');

      function showPick(on) {
        if (buy) buy.classList.toggle('metab-duo__cta--hidden', on);
        if (pick) pick.classList.toggle('metab-duo__pick--hidden', !on);
      }
      if (addBtn) addBtn.addEventListener('click', function () { showPick(true); });
      if (backBtn) backBtn.addEventListener('click', function () { showPick(false); });

      root.querySelectorAll('[data-bx-duo-flavor]').forEach(function (b) {
        b.addEventListener('click', function () {
          var flavor = b.getAttribute('data-bx-duo-flavor');
          var shakeId = cfg[flavor];
          var items = [];
          if (cfg.metab) items.push({ id: cfg.metab, quantity: 1 });
          if (shakeId) items.push({ id: shakeId, quantity: 1 });
          if (!items.length) { showPick(false); return; }
          b.disabled = true;
          if (window.BiomeCart && window.BiomeCart.addAndOpen) {
            window.BiomeCart.addAndOpen(items, {}).then(function () { b.disabled = false; showPick(false); }).catch(function () { b.disabled = false; });
          } else {
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
              .then(function () { window.location.href = '/cart'; }).catch(function () { b.disabled = false; });
          }
        });
      });
    }
    function boot() { document.querySelectorAll('[data-biome-metab-duo]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-metab-energy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HOURS = ["6am", "8", "10", "12", "2pm", "4", "6", "8", "10pm"];
    var COFFEE = [10, 78, 55, 32, 70, 22, 50, 38, 18];
    var BOOSTER = [30, 55, 70, 72, 70, 65, 58, 45, 28];

    function smoothPath(pts, xs, ys) {
      if (pts.length < 2) return "";
      var f = function (n) { return n.toFixed(2); };
      var d = "M" + f(xs[0]) + "," + f(ys[0]);
      for (var i = 0; i < pts.length - 1; i++) {
        var p0 = i === 0 ? i : i - 1;
        var p3 = i + 2 >= pts.length ? i + 1 : i + 2;
        var c1x = xs[i] + (xs[i + 1] - xs[p0]) / 6;
        var c1y = ys[i] + (ys[i + 1] - ys[p0]) / 6;
        var c2x = xs[i + 1] - (xs[p3] - xs[i]) / 6;
        var c2y = ys[i + 1] - (ys[p3] - ys[i]) / 6;
        d += " C" + f(c1x) + "," + f(c1y) + " " + f(c2x) + "," + f(c2y) + " " + f(xs[i + 1]) + "," + f(ys[i + 1]);
      }
      return d;
    }

    function buildChart(svg) {
      var SVGNS = "http://www.w3.org/2000/svg";
      var w = 600, h = 280, padL = 32, padR = 24, padT = 32, padB = 48;
      var innerW = w - padL - padR, innerH = h - padT - padB;
      var N = HOURS.length;
      var xFor = function (i) { return padL + (i / (N - 1)) * innerW; };
      var yFor = function (v) { return padT + innerH * (1 - v / 100); };
      var xs = HOURS.map(function (_, i) { return xFor(i); });
      var coffeeYs = COFFEE.map(yFor), boosterYs = BOOSTER.map(yFor);
      var coffeePath = smoothPath(COFFEE, xs, coffeeYs);
      var boosterPath = smoothPath(BOOSTER, xs, boosterYs);
      var crashX1 = xFor(4), crashX2 = xFor(5);

      function el(name, attrs, text) {
        var n = document.createElementNS(SVGNS, name);
        for (var k in attrs) { if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]); }
        if (text != null) n.textContent = text;
        return n;
      }

      svg.appendChild(el("rect", { x: crashX1, y: padT, width: crashX2 - crashX1, height: innerH, fill: "var(--terracotta)", opacity: "0.07" }));
      svg.appendChild(el("text", { x: (crashX1 + crashX2) / 2, y: padT + 16, fill: "var(--terracotta)", "font-family": "var(--mono)", "font-size": "9.5", "letter-spacing": "0.12em", "text-anchor": "middle", style: "text-transform:uppercase" }, "Crash zone"));
      svg.appendChild(el("line", { x1: padL, x2: w - padR, y1: padT + innerH, y2: padT + innerH, stroke: "var(--line)", "stroke-width": "1" }));

      svg.appendChild(el("path", { d: coffeePath, fill: "none", stroke: "var(--terracotta)", "stroke-width": "1.4", "stroke-linecap": "round", "stroke-linejoin": "round", opacity: "0.55" }));
      svg.appendChild(el("path", { d: coffeePath, pathLength: "100", fill: "none", stroke: "var(--terracotta)", "stroke-width": "3.6", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-dasharray": "5 18", "class": "metab-energy__pulse metab-energy__pulse--coffee" }));
      COFFEE.forEach(function (v, i) { svg.appendChild(el("circle", { cx: xs[i], cy: coffeeYs[i], r: "2.5", fill: "var(--terracotta)" })); });

      svg.appendChild(el("path", { d: boosterPath, fill: "none", stroke: "var(--forest)", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round", opacity: "0.55" }));
      svg.appendChild(el("path", { d: boosterPath, pathLength: "100", fill: "none", stroke: "var(--forest)", "stroke-width": "4", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-dasharray": "5 18", "class": "metab-energy__pulse metab-energy__pulse--booster" }));
      BOOSTER.forEach(function (v, i) { svg.appendChild(el("circle", { cx: xs[i], cy: boosterYs[i], r: "3", fill: "var(--forest)" })); });

      HOURS.forEach(function (lbl, i) { svg.appendChild(el("text", { x: xs[i], y: padT + innerH + 18, fill: "var(--ink-2)", "font-family": "var(--mono)", "font-size": "10", "letter-spacing": "0.04em", "text-anchor": "middle" }, lbl)); });
      svg.appendChild(el("text", { x: padL - 4, y: padT - 6, fill: "var(--sage)", "font-family": "var(--mono)", "font-size": "9", "letter-spacing": "0.1em", "text-anchor": "start", style: "text-transform:uppercase" }, "Felt energy"));
      svg.appendChild(el("text", { x: padL - 4, y: padT + innerH + 8, fill: "var(--sage)", "font-family": "var(--mono)", "font-size": "9", "letter-spacing": "0.1em", "text-anchor": "start", style: "text-transform:uppercase" }, "Baseline"));
    }

    function boot() {
      document.querySelectorAll('[data-biome-metab-energy] [data-bx-energy-chart]').forEach(function (svg) {
        if (svg.childNodes.length) return;
        buildChart(svg);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-metab-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var items = root.querySelectorAll('[data-bx-faq]');
      items.forEach(function (item) {
        function toggle() {
          var isOpen = item.classList.contains('faq__item--open');
          // close all (single-open accordion, matching the prototype)
          items.forEach(function (i) { i.classList.remove('faq__item--open'); });
          if (!isOpen) item.classList.add('faq__item--open');
        }
        item.addEventListener('click', toggle);
        item.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      });
      // nutrition trigger items: keyboard parity (click handled by the global [data-bx-nutrition] listener)
      root.querySelectorAll('.metab-faq__item--nutrition').forEach(function (item) {
        item.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); } });
      });
    }
    function boot() { document.querySelectorAll('[data-biome-metab-faq]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-metab-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(n) {
      var v = Math.round(Number(n) * 100) / 100;
      return Number.isInteger(v) ? String(v) : v.toFixed(2);
    }
    function initMetabPdp(root) {
      var cfgEl = root.querySelector('[data-bx-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

      var BASE = cfg.base;
      var SUB = [BASE - cfg.subDiscount, BASE - cfg.vol2 - cfg.subDiscount, BASE - cfg.vol3 - cfg.subDiscount, BASE - cfg.vol6 - cfg.subDiscount];
      var ONCE = [BASE, BASE - cfg.vol2, BASE - cfg.vol3, BASE - cfg.vol6];
      var CAPS = cfg.capsules, DAILY = cfg.daily, FREE = cfg.freeShipMin;
      var DAYS_PER_BOTTLE = CAPS / DAILY;

      function tier(qty) { if (qty <= 1) return 0; if (qty === 2) return 1; if (qty <= 5) return 2; return 3; }
      function price(qty, plan) { return (plan === 'sub' ? SUB : ONCE)[tier(qty)]; }
      function totals(qty, plan) {
        var unit = price(qty, plan);
        var subtotal = +fmt(unit * qty);
        var baseSubtotal = +fmt(BASE * qty);
        var savings = +fmt(baseSubtotal - subtotal);
        return { unit: unit, subtotal: subtotal, baseSubtotal: baseSubtotal, savings: savings, freeShip: subtotal >= FREE, qty: qty, days: qty * DAYS_PER_BOTTLE, tier: tier(qty) };
      }

      var state = { qty: 3, preset: '3', plan: cfg.defaultPlan === 'once' ? 'once' : 'sub', freq: 6, freqManual: false };

      function businessEta(n) {
        var d = new Date(); var added = 0;
        while (added < n) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
        return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      }

      // ── milestone bar (built once, updated in place so the fill transition animates) ──
      function buildMilestone() {
        var sav1 = (ONCE[0] - ONCE[1]).toFixed(0), sav2 = (ONCE[0] - ONCE[2]).toFixed(0), sav3 = (ONCE[0] - ONCE[3]).toFixed(0);
        return '' +
          '<div class="ms-twin" data-ms-root>' +
            '<div class="ms-twin__bar ms-twin__bar--tall" data-ms-bar>' +
              '<div class="ms-twin__fill" data-ms-fill></div>' +
              '<span class="ms-twin__inside" data-ms-inside>' +
                '<span class="ms-twin__inside-icon"><svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M1 4.5h8v6.5H1zM9 6.5h2.7l2.3 2.3v2.2H9z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="4" cy="12.5" r="1.4" fill="currentColor"/><circle cx="12" cy="12.5" r="1.4" fill="currentColor"/></svg></span>' +
                '<span data-ms-shiptext></span>' +
              '</span>' +
              '<span class="ms-twin__dot" style="left:0%" data-ms-dot0></span>' +
              '<span class="ms-twin__dot" style="left:100%" data-ms-dot100></span>' +
            '</div>' +
            '<div class="ms-twin__row ms-twin__row--bot">' +
              '<span class="ms-twin__marker ms-twin__marker--l" style="left:0%"><span class="ms-twin__marker-qty" data-ms-mk0>1 Unit</span></span>' +
              '<span class="ms-twin__marker" style="left:33.33%"><span class="ms-twin__marker-qty" data-ms-mk2q>2</span><span class="ms-twin__marker-perk" data-ms-mk2p>−$' + sav1 + '<span class="ms-twin__marker-perk-unit"> / unit</span></span></span>' +
              '<span class="ms-twin__marker" style="left:66.67%"><span class="ms-twin__marker-qty" data-ms-mk3q>3+</span><span class="ms-twin__marker-perk" data-ms-mk3p>−$' + sav2 + '<span class="ms-twin__marker-perk-unit"> / unit</span></span></span>' +
              '<span class="ms-twin__marker ms-twin__marker--r" style="left:100%"><span class="ms-twin__marker-qty" data-ms-mk6q>6+</span><span class="ms-twin__marker-perk" data-ms-mk6p>−$' + sav3 + '<span class="ms-twin__marker-perk-unit"> / unit</span></span></span>' +
            '</div>' +
          '</div>';
      }
      function cacheMsEls() {
        var q = function (s) { return els.ms.querySelector(s); };
        els.msEls = {
          root: q('[data-ms-root]'), bar: q('[data-ms-bar]'), fill: q('[data-ms-fill]'),
          inside: q('[data-ms-inside]'), shiptext: q('[data-ms-shiptext]'),
          dot0: q('[data-ms-dot0]'), dot100: q('[data-ms-dot100]'),
          mk0: q('[data-ms-mk0]'), mk2q: q('[data-ms-mk2q]'), mk2p: q('[data-ms-mk2p]'),
          mk3q: q('[data-ms-mk3q]'), mk3p: q('[data-ms-mk3p]'), mk6q: q('[data-ms-mk6q]'), mk6p: q('[data-ms-mk6p]')
        };
      }
      function setDot(el, reached, accent, allFull) {
        var c = reached ? (accent || (allFull ? 'var(--terracotta)' : 'var(--forest)')) : 'var(--cream-2)';
        var b = reached ? (accent || (allFull ? 'var(--terracotta)' : 'var(--forest)')) : 'var(--sage)';
        el.style.background = c; el.style.borderColor = b;
      }
      function updateMilestone(t) {
        var ms = els.msEls; if (!ms) return;
        var qty = t.qty, tr = t.tier;
        var pct = tr === 0 ? 16 : tr === 1 ? 50 : tr === 2 ? 83 : 100;
        var allFull = tr === 3;
        var fillColor = allFull ? 'var(--terracotta)' : 'var(--forest)';
        ms.root.classList.toggle('ms-twin--all-full', allFull);
        ms.bar.style.setProperty('--ms-pct', pct + '%');
        ms.fill.style.width = pct + '%';
        ms.fill.style.background = fillColor;
        ms.fill.classList.toggle('ms-twin__fill--full', pct >= 100);
        ms.inside.classList.toggle('ms-twin__inside--on', t.freeShip);
        ms.shiptext.textContent = t.freeShip ? 'Free shipping unlocked' : 'Free shipping at $' + FREE;
        setDot(ms.dot0, qty >= 1, null, allFull);
        setDot(ms.dot100, tr === 3, 'var(--terracotta)', allFull);
        ms.mk0.style.color = qty >= 1 ? 'var(--ink)' : 'var(--ink-2)';
        ms.mk2q.style.color = qty >= 2 ? 'var(--ink)' : 'var(--ink-2)';
        ms.mk2p.style.color = qty >= 2 ? 'var(--forest)' : 'var(--sage)';
        ms.mk3q.style.color = qty >= 3 ? 'var(--ink)' : 'var(--ink-2)';
        ms.mk3p.style.color = qty >= 3 ? 'var(--forest)' : 'var(--sage)';
        ms.mk6q.style.color = tr === 3 ? 'var(--ink)' : 'var(--ink-2)';
        ms.mk6p.style.color = tr === 3 ? 'var(--terracotta-2)' : 'var(--sage)';
      }

      var els = {
        opts: root.querySelectorAll('[data-bx-preset]'),
        preset1Sub: root.querySelector('[data-bx-preset-sub="1"]'),
        custom: root.querySelector('[data-bx-custom]'),
        val: root.querySelector('[data-bx-val]'),
        dec: root.querySelector('[data-bx-dec]'),
        inc: root.querySelector('[data-bx-inc]'),
        subTag: root.querySelector('[data-bx-sub-tag]'),
        subPpd: root.querySelector('[data-bx-sub-ppd]'),
        subPpb: root.querySelector('[data-bx-sub-ppb]'),
        subPerk: root.querySelector('[data-bx-sub-perk]'),
        oncePpd: root.querySelector('[data-bx-once-ppd]'),
        oncePpb: root.querySelector('[data-bx-once-ppb]'),
        servingsTotal: root.querySelector('[data-bx-servings-total]'),
        cadence: root.querySelector('[data-bx-cadence]'),
        eta: root.querySelector('[data-bx-eta]'),
        atc: root.querySelector('[data-bx-atc]'),
        ms: root.querySelector('[data-bx-ms]'),
        freq: root.querySelector('[data-bx-freq]'),
        planSub: root.querySelector('[data-bx-plan="sub"]'),
        planOnce: root.querySelector('[data-bx-plan="once"]'),
        satc: root.querySelector('[data-bx-satc]'),
        satcTitle: root.querySelector('[data-bx-satc-title]'),
        satcSub: root.querySelector('[data-bx-satc-sub]'),
        satcPrice: root.querySelector('[data-bx-satc-price]'),
        satcThumb: root.querySelector('[data-bx-satc-thumb]'),
        satcBtn: root.querySelector('[data-bx-satc-btn]'),
        satcLabel: root.querySelector('[data-bx-satc-label]'),
        navAtcLabel: document.querySelector('[data-bx-navatc-label]'),
        navAtcTitle: document.querySelector('[data-bx-navatc-title]'),
        navAtcStrike: document.querySelector('[data-bx-navatc-strike]'),
        navAtcNum: document.querySelector('[data-bx-navatc-num]')
      };

      function render() {
        var t = totals(state.qty, state.plan);

        // supply cards selected state + per-preset savings
        els.opts.forEach(function (opt) {
          var on = opt.getAttribute('data-bx-preset') === state.preset;
          opt.classList.toggle('metab-qty__opt--on', on);
          opt.setAttribute('aria-pressed', on ? 'true' : 'false');
          var fixed = opt.getAttribute('data-bx-qty');
          if (fixed) {
            var sav = BASE - price(Number(fixed), state.plan);
            var savEl = opt.querySelector('[data-bx-preset-sav-num]');
            if (savEl) savEl.textContent = sav;
          }
        });
        // custom stepper value + minus disabled state
        if (els.val) els.val.textContent = state.qty;
        // 1-bottle card supply tracks ITS OWN qty — 1 by default, the stepper value when it's the
        // active tier — never the selected fixed tier's qty. Weeks (mirrors the bloating PDP).
        var preset1Qty = state.preset === '1' ? state.qty : 1;
        if (els.preset1Sub) els.preset1Sub.textContent = (preset1Qty * DAYS_PER_BOTTLE / 7) + '-week supply';
        if (els.dec) {
          var canDec = state.qty > 1;
          els.dec.disabled = !canDec;
          els.dec.classList.toggle('stepper__btn--off', !canDec);
        }

        // plan prices
        var subUnit = price(state.qty, 'sub'), onceUnit = price(state.qty, 'once');
        var subPerDay = +fmt(subUnit / DAYS_PER_BOTTLE), oncePerDay = +fmt(onceUnit / DAYS_PER_BOTTLE);
        var perBottleSav = BASE - subUnit, totalSav = perBottleSav * state.qty;
        els.subTag.textContent = 'Save $' + totalSav + ' · most popular';
        els.subPpd.textContent = '$' + subPerDay + ' / serving';
        els.subPpb.innerHTML = '<span class="pln__pricecol-num pln__pricecol-num--sale"><span class="pln__pricecol-strike">$' + BASE + '</span>$' + subUnit + '<span class="pln__pricecol-unit">/ bottle</span></span>';
        els.subPerk.textContent = '$' + perBottleSav + ' off every bottle, every order';
        var onceStrike = onceUnit < BASE;
        els.oncePpd.textContent = '$' + oncePerDay + ' / serving';
        els.oncePpb.innerHTML = '<span class="pln__pricecol-num ' + (onceStrike ? 'pln__pricecol-num--sale' : '') + '">' + (onceStrike ? '<span class="pln__pricecol-strike">$' + BASE + '</span>' : '') + '$' + onceUnit + '<span class="pln__pricecol-unit">/ bottle</span></span>';

        // plan selected state
        els.planSub.classList.toggle('pln--on', state.plan === 'sub');
        els.planOnce.classList.toggle('pln--on', state.plan === 'once');

        // servings total + cadence + freq
        els.servingsTotal.textContent = (state.qty * DAYS_PER_BOTTLE) + ' SERVINGS TOTAL';
        if (els.freq) { els.freq.value = String(state.freq); els.freq.dispatchEvent(new CustomEvent('flipdd:sync')); }
        if (els.cadence) {
          var spw = state.qty * DAYS_PER_BOTTLE / state.freq;
          els.cadence.textContent = '≈ ' + spw.toFixed(spw % 1 === 0 ? 0 : 1) + ' servings / week';
        }

        // eta
        var etaStr = businessEta(3);
        els.eta.innerHTML = state.plan === 'sub'
          ? '1st delivery <strong class="bx-eta-strong">' + etaStr + '</strong> then every ' + state.freq + ' weeks'
          : 'Estimated delivery: <strong class="bx-eta-strong">' + etaStr + '</strong>';

        // ATC
        els.atc.innerHTML = '<span class="bx-flex-left">Add ' + state.qty + ' ' + (state.qty === 1 ? 'bottle' : 'bottles') + (t.savings > 0 ? ' · Save $' + fmt(t.savings) : '') + '</span>' +
          '<span class="bx-atc-pricegrp">' +
          (t.savings > 0 ? '<span class="bx-atc-strike">$' + fmt(t.baseSubtotal) + '</span>' : '') +
          '<span class="bx-atc-total">$' + fmt(t.subtotal) + '</span></span>';

        // milestones
        if (!els.msEls) { els.ms.innerHTML = buildMilestone(); cacheMsEls(); }
        updateMilestone(t);

        // sticky ATC
        if (els.satc) {
          els.satcThumb.textContent = '×' + state.qty;
          els.satcTitle.textContent = state.qty + ' ' + (state.qty === 1 ? 'bottle' : 'bottles') + ' · ' + (state.qty * DAYS_PER_BOTTLE) + ' servings';
          var tierTxt = t.tier === 3 ? 'best price' : (t.tier >= 1 ? '$' + (ONCE[0] - ONCE[t.tier]) + ' off / bottle' : '');
          els.satcSub.textContent = (state.plan === 'sub' ? 'Subscribe & save $' + perBottleSav + '/bottle' : 'One-time purchase') + (tierTxt ? ' · ' + tierTxt : '') + (t.freeShip ? ' · free shipping' : '');
          els.satcPrice.innerHTML = (t.savings > 0 ? '<span class="satc__price-strike">$' + fmt(t.baseSubtotal) + '</span>' : '') + '$' + fmt(t.subtotal);
        }

        // nav smart-ATC (header, compact mode) — mirror the hero selection
        if (els.navAtcLabel) {
          var navUnit = state.plan === 'sub' ? subUnit : onceUnit;
          els.navAtcLabel.textContent = state.qty + ' ' + (state.qty === 1 ? 'bottle' : 'bottles') + ' · ' + (state.plan === 'sub' ? 'Subscribe' : 'One-time');
          els.navAtcTitle.textContent = (state.qty * DAYS_PER_BOTTLE) + ' servings · $' + navUnit + '/bottle';
          if (els.navAtcStrike) {
            if (t.savings > 0) { els.navAtcStrike.hidden = false; els.navAtcStrike.textContent = '$' + fmt(t.baseSubtotal); }
            else els.navAtcStrike.hidden = true;
          }
          els.navAtcNum.textContent = '$' + fmt(t.subtotal);
        }
      }

      // ── preset / stepper events ──
      function selectPreset(p, qty) {
        state.preset = p;
        if (qty != null) state.qty = qty;
        else if (p === '1') state.qty = 1;
        snapFreq();
        render();
      }
      function snapFreq() {
        var target = Math.min(state.qty * 2, 12);
        state.freq = [2, 4, 6, 8, 10, 12].reduce(function (a, b) { return Math.abs(b - target) < Math.abs(a - target) ? b : a; });
        state.freqManual = false;        // qty changed → auto cadence wins again
      }
      els.opts.forEach(function (opt) {
        var p = opt.getAttribute('data-bx-preset');
        var fixed = opt.getAttribute('data-bx-qty');
        function pick() { selectPreset(p, fixed ? Number(fixed) : null); }
        opt.addEventListener('click', function (e) {
          if (e.target.closest('[data-bx-stepper]')) return;
          pick();
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
        });
      });
      if (els.inc) els.inc.addEventListener('click', function (e) { e.stopPropagation(); state.preset = '1'; state.qty = state.qty + 1; snapFreq(); render(); });
      if (els.dec) els.dec.addEventListener('click', function (e) { e.stopPropagation(); if (state.qty > 1) { state.preset = '1'; state.qty = state.qty - 1; snapFreq(); render(); } });

      // Whole plan card is the select target (delegated). Guard real form controls so the
      // frequency <select> still opens without re-selecting the plan.
      root.addEventListener('click', function (e) {
        if (e.target.closest('select, input, option')) return;
        var planSel = e.target.closest('[data-bx-plan-select]');
        if (planSel) { state.plan = planSel.getAttribute('data-bx-plan-select'); render(); }
      });
      if (els.freq) els.freq.addEventListener('change', function () { state.freq = Number(els.freq.value); state.freqManual = true; render(); });

      // ── ATC → (first-time partner nudge) → AJAX add via window.BiomeCart ──
      function commitAdd(qty) {
        if (!cfg.variant || qty <= 0) return;
        var props = { _plan: state.plan };
        if (state.plan === 'sub') props._delivery_weeks = String(state.freq);
        var items = [{ id: cfg.variant, quantity: qty, properties: props }];
        els.atc.disabled = true;
        if (window.BiomeCart && window.BiomeCart.addAndOpen) {
          window.BiomeCart.addAndOpen(items, { plan: state.plan, freq: state.freq, freqManual: state.freqManual })
            .then(function () { els.atc.disabled = false; })
            .catch(function () { els.atc.disabled = false; });
        } else {
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { window.location.href = '/cart'; })
            .catch(function () { els.atc.disabled = false; });
        }
      }
      function nudgeSeen() { return /(?:^|; )biome_partner_nudge_seen=1(?:;|$)/.test(document.cookie || ''); }
      function markNudgeSeen() { try { document.cookie = 'biome_partner_nudge_seen=1; max-age=' + (60 * 60 * 24 * 365) + '; path=/; samesite=lax'; } catch (e) {} }
      var pn = root.querySelector('[data-bx-nudge]');
      var pnBack = root.querySelector('[data-bx-nudge-back]');
      function openNudge() {
        if (!pn) { commitAdd(state.qty); return; }
        var soloPpb = price(state.qty, state.plan);
        var partnerPpb = price(state.qty * 2, state.plan);
        var sav = Math.max(0, soloPpb - partnerPpb);
        var savEl = root.querySelector('[data-bx-nudge-sav]');
        if (savEl) savEl.innerHTML = sav > 0 ? (' and you’ll save <b>an extra $' + sav + ' per bottle</b>.') : ' shipped in the same box.';
        pn.classList.add('pn--open'); pn.setAttribute('aria-hidden', 'false');
        if (pnBack) pnBack.classList.add('pn-back--open');
        document.body.style.overflow = 'hidden';
      }
      function closeNudge() { if (pn) { pn.classList.remove('pn--open'); pn.setAttribute('aria-hidden', 'true'); } if (pnBack) pnBack.classList.remove('pn-back--open'); document.body.style.overflow = ''; }
      function nudgeSolo() { markNudgeSeen(); closeNudge(); commitAdd(state.qty); }
      function nudgePartner() {
        markNudgeSeen(); closeNudge();
        state.freq = Math.min(12, state.freq * 2);   // 2× the basket → 2× the cadence
        render();
        commitAdd(state.qty * 2);
      }
      els.atc.addEventListener('click', function () {
        if (state.qty <= 0) return;
        if (nudgeSeen()) commitAdd(state.qty); else openNudge();
      });
      root.querySelectorAll('[data-bx-nudge-solo]').forEach(function (b) { b.addEventListener('click', nudgeSolo); });
      root.querySelectorAll('[data-bx-nudge-partner]').forEach(function (b) { b.addEventListener('click', nudgePartner); });
      if (pnBack) pnBack.addEventListener('click', nudgeSolo);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pn && pn.classList.contains('pn--open')) nudgeSolo(); });

      // ── sticky ATC: reuse hero handler; surface on scroll past the buy-box ──
      if (els.satcBtn) els.satcBtn.addEventListener('click', function () { els.atc.click(); });
      var heroAtc = root.querySelector('.atcw');
      function onSatcScroll() {
        if (!els.satc) return;
        var past = heroAtc ? heroAtc.getBoundingClientRect().bottom < 0 : false;
        var fin = document.querySelector('footer.footer, .bs-fcta, .metab-final');
        var atEnd = fin ? fin.getBoundingClientRect().top < (window.innerHeight - 80) : false;
        els.satc.classList.toggle('satc--show', past && !atEnd);
      }
      window.addEventListener('scroll', onSatcScroll, { passive: true });
      onSatcScroll();

      // gallery — main crossfade shots + thumbnails. Both desktop and mobile use a
      // horizontal scroll rail (swipe on touch / drag with a mouse). Desktop caps the
      // rail at 5 thumbs (CSS max-width) and keeps the flanking arrows, which page it.
      var shots = root.querySelectorAll('[data-bx-shot]');
      var thumbs = root.querySelectorAll('[data-bx-thumb]');
      var dots = root.querySelectorAll('[data-bx-dot]');
      var countEl = root.querySelector('[data-bx-count]');
      var track = root.querySelector('[data-bx-thumbs]');
      var tprev = root.querySelector('[data-bx-thumb-prev]'), tnext = root.querySelector('[data-bx-thumb-next]');
      var gi = 0;
      function loadShot(n) {
        var s = shots[n];
        if (s && !s.getAttribute('src') && s.getAttribute('data-bx-shot-src')) { s.setAttribute('src', s.getAttribute('data-bx-shot-src')); }
      }
      // Every thumb lives in the rail (no windowing); fade each thumb img in once it loads (no popping).
      thumbs.forEach(function (b) {
        b.hidden = false;
        var im = b.querySelector('img');
        if (im && !im.complete) { im.classList.add('is-fading'); var on = function () { im.classList.add('is-loaded'); }; im.addEventListener('load', on); im.addEventListener('error', on); }
      });
      // Enable/disable the flanking arrows based on how far the rail is scrolled.
      function syncArrows() {
        if (!track) return;
        var max = track.scrollWidth - track.clientWidth;
        if (tprev) tprev.disabled = track.scrollLeft <= 1;
        if (tnext) tnext.disabled = track.scrollLeft >= max - 1;
      }
      function pageBy(dir) {                                    // arrows scroll the rail by one visible page
        if (!track) return;
        var step = (thumbs.length > 1) ? (thumbs[1].offsetLeft - thumbs[0].offsetLeft) : 74;
        var per = Math.max(1, Math.round(track.clientWidth / step));
        track.scrollBy({ left: dir * per * step, behavior: 'smooth' });
      }
      function setShot(i, skipScroll) {
        if (!shots.length) return;
        var total = shots.length;
        gi = (i + total) % total;
        loadShot(gi); loadShot((gi + 1) % total); loadShot((gi - 1 + total) % total);
        shots.forEach(function (s, n) { s.classList.toggle('bx-shot--on', n === gi); });
        thumbs.forEach(function (b, n) {
          b.classList.toggle('hero-thumbs__btn--on', n === gi);
          b.classList.toggle('hero-thumbs__btn--off', n !== gi);
        });
        if (!skipScroll && thumbs[gi] && thumbs[gi].scrollIntoView) {          // keep the active thumb in view in the rail (not on init — would scroll the page to the gallery)
          thumbs[gi].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
        dots.forEach(function (d, n) { d.classList.toggle('hero-thumbs__dot--on', n === gi); });
        if (countEl) countEl.textContent = ('0' + (gi + 1)).slice(-2) + ' / ' + ('0' + total).slice(-2);
      }
      thumbs.forEach(function (b, n) { b.addEventListener('click', function () { setShot(n); }); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { setShot(n); }); });
      var prev = root.querySelector('[data-bx-prev]'), next = root.querySelector('[data-bx-next]');
      if (prev) prev.addEventListener('click', function () { setShot(gi - 1); });
      if (next) next.addEventListener('click', function () { setShot(gi + 1); });
      // Thumbnail arrows page the rail (desktop) — browse beyond the first five.
      if (tprev) tprev.addEventListener('click', function () { pageBy(-1); });
      if (tnext) tnext.addEventListener('click', function () { pageBy(1); });
      if (track) {
        track.addEventListener('scroll', syncArrows, { passive: true });
        window.addEventListener('resize', syncArrows);
        // Mouse: drag the rail to scroll. Move/up are bound to the window during a drag, so letting
        // go anywhere (even off the rail) reliably ends it. A press that doesn't move selects that
        // thumb on release (snap-proof — uses the thumb you pressed). Touch + keyboard use the
        // thumbs' own click handlers above.
        var down = false, sx = 0, sl = 0, moved = false, pressIdx = -1, ptrType = '', snapRAF = 0;
        function thumbStep() { return thumbs.length > 1 ? (thumbs[1].offsetLeft - thumbs[0].offsetLeft) : 74; }
        function gentleSnap(target) {                           // ease (decelerate) into the nearest thumb edge
          cancelAnimationFrame(snapRAF);
          var startL = track.scrollLeft, dist = target - startL, t0 = 0;
          if (Math.abs(dist) < 1) { track.classList.remove('is-dragging'); return; }
          function tick(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / 340);
            track.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));   // easeOutCubic
            if (p < 1) { snapRAF = requestAnimationFrame(tick); }
            else { track.classList.remove('is-dragging'); }
          }
          snapRAF = requestAnimationFrame(tick);
        }
        function onMove(e) {
          if (!down) return;
          var dx = e.clientX - sx;
          if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }   // a real drag has begun
          if (moved) track.scrollLeft = sl - dx;
        }
        function endDrag() {
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', endDrag);
          window.removeEventListener('pointercancel', endDrag);
          if (!down) return;
          down = false;
          if (moved) { gentleSnap(Math.round(track.scrollLeft / thumbStep()) * thumbStep()); }
          else { track.classList.remove('is-dragging'); if (pressIdx > -1) setShot(pressIdx); }    // a tap selects the pressed thumb
          pressIdx = -1;
        }
        track.addEventListener('pointerdown', function (e) {
          ptrType = e.pointerType;
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          var b = e.target.closest('[data-bx-thumb]');
          pressIdx = b ? Array.prototype.indexOf.call(thumbs, b) : -1;
          down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
          cancelAnimationFrame(snapRAF);                        // grabbing again interrupts an in-flight snap
          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', endDrag);
          window.addEventListener('pointercancel', endDrag);
        });
        // Mouse selection is handled on pointerup (endDrag) — swallow the synthetic mouse click so it
        // neither double-fires nor (after a drag) switches the shot. Touch/keyboard clicks pass through.
        track.addEventListener('click', function (e) { if (ptrType === 'mouse' && e.detail > 0) { e.preventDefault(); e.stopPropagation(); } }, true);
        // Block native image dragging so a drag that starts ON a thumb still scrolls the rail.
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      // Touch: swipe the hero image left/right to change the shot.
      function bxSwipe(el) {
        if (!el) return;
        var sx = 0, sy = 0, st = 0;
        el.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); }, { passive: true });
        el.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) < 36 || Math.abs(dx) <= Math.abs(dy) || Date.now() - st > 800) return;
          setShot(gi + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
      bxSwipe(root.querySelector('[data-bx-gallery]'));
      setShot(0, true); // init: skip the scrollIntoView (would yank the page to the gallery on load)
      syncArrows();

      render();
    }
    function boot() { document.querySelectorAll('[data-biome-metab-pdp]').forEach(initMetabPdp); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-metab-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var scroller = root.querySelector('[data-bx-ing-scroller]');
      var dots = root.querySelectorAll('[data-bx-ing-dot]');
      if (!scroller || !dots.length) return;

      function setActive(i) {
        dots.forEach(function (d, n) {
          d.classList.toggle('metab-ing__dot--on', n === i);
          d.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
      }
      function onScroll() {
        var cards = scroller.querySelectorAll('.metab-ing__card');
        if (!cards.length) return;
        var center = scroller.scrollLeft + scroller.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (c, i) {
          var cc = c.offsetLeft + c.offsetWidth / 2;
          var d = Math.abs(cc - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        setActive(best);
      }
      scroller.addEventListener('scroll', onScroll, { passive: true });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var card = scroller.querySelectorAll('.metab-ing__card')[i];
          if (card) scroller.scrollTo({ left: card.offsetLeft - 16, behavior: 'smooth' });
        });
      });
    }
    function boot() { document.querySelectorAll('[data-biome-metab-ing]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-metab-pillars"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var tabs = root.querySelectorAll('[data-bx-pillar-tab]');
      var panels = root.querySelectorAll('[data-bx-pillar-panel]');
      if (!tabs.length) return;
      function show(i) {
        tabs.forEach(function (t, n) {
          t.classList.toggle('metab-pillars__tab--on', n === i);
          t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
        panels.forEach(function (p, n) {
          var on = n === i;
          p.classList.toggle('metab-pillars__panel--hidden', !on);
          if (on) {
            // restart the fade-in animation on switch
            p.style.animation = 'none';
            void p.offsetWidth;
            p.style.animation = '';
          }
        });
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    }
    function boot() { document.querySelectorAll('[data-biome-metab-pillars]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-metab-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var PAGE_SIZE = Number(root.getAttribute('data-page-size')) || 6;
      var MAX_PAGES = Number(root.getAttribute('data-max-pages')) || 2;
      var filterBtns = root.querySelectorAll('[data-bx-rev-filter]');
      var cards = root.querySelectorAll('[data-bx-rev-card]');
      var extras = root.querySelectorAll('[data-bx-rev-extra]');
      var loadBtn = root.querySelector('[data-bx-rev-loadmore]');
      var loadLabel = root.querySelector('[data-bx-rev-loadmore-label]');
      var showing = root.querySelector('[data-bx-rev-showing]');
      var viewAll = root.querySelector('[data-bx-rev-viewall]');
      var totalStr = root.getAttribute('data-total') || '';
      var initialLabel = loadLabel ? loadLabel.textContent : 'Read all reviews';

      var state = { filter: 'all', pages: 0 };

      function matches(el) {
        if (state.filter === 'all') return true;
        var tags = (el.getAttribute('data-tags') || '');
        return tags.split(',').map(function (t) { return t.trim(); }).indexOf(state.filter) !== -1;
      }

      function apply() {
        // featured cards: show all matching
        var shownCards = 0;
        cards.forEach(function (c) {
          var on = matches(c);
          c.classList.toggle('metab-rev__card--hidden', !on);
          if (on) shownCards++;
        });
        // extras (compact): matching ones, up to pages * PAGE_SIZE
        var matchingExtras = [];
        extras.forEach(function (e) { if (matches(e)) matchingExtras.push(e); });
        var limit = state.pages * PAGE_SIZE;
        var shownExtras = 0;
        extras.forEach(function (e) { e.hidden = true; });
        matchingExtras.forEach(function (e, i) { if (i < limit) { e.hidden = false; shownExtras++; } });
        var remaining = Math.max(0, matchingExtras.length - shownExtras);

        // load-more control states
        var totalTxt = totalStr || String(cards.length + extras.length);
        if (state.pages === 0) {
          loadBtn.hidden = false;
          if (loadLabel) loadLabel.textContent = initialLabel;
          if (showing) showing.hidden = true;
          if (viewAll) viewAll.hidden = true;
        } else if (state.pages < MAX_PAGES && remaining > 0) {
          loadBtn.hidden = false;
          if (loadLabel) loadLabel.textContent = 'Load ' + Math.min(PAGE_SIZE, remaining) + ' more reviews';
          if (showing) { showing.hidden = false; showing.textContent = 'Showing ' + (shownCards + shownExtras) + ' of ' + totalTxt; }
          if (viewAll) viewAll.hidden = true;
        } else {
          loadBtn.hidden = true;
          if (showing) showing.hidden = true;
          if (viewAll) viewAll.hidden = false;
        }
      }

      filterBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          filterBtns.forEach(function (x) { x.classList.remove('metab-rev__filter--on'); });
          b.classList.add('metab-rev__filter--on');
          state.filter = b.getAttribute('data-bx-rev-filter');
          state.pages = 0;
          apply();
        });
      });
      if (loadBtn) loadBtn.addEventListener('click', function () { state.pages = Math.min(MAX_PAGES, state.pages + 1); apply(); });

      apply();
    }
    function boot() { document.querySelectorAll('[data-biome-metab-rev]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-pack-offer-hero"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initPO2(root) {
        if (root.dataset.poInit) return;
        root.dataset.poInit = '1';

        /* ----- gallery (drives the superfood PDP bx-* markup) ----- */
        var shots = root.querySelectorAll('[data-bx-shot]');
        var thumbs = root.querySelectorAll('[data-bx-thumb]');
        var dots = root.querySelectorAll('[data-bx-dot]');
        var countEl = root.querySelector('[data-bx-count]');
        var track = root.querySelector('[data-bx-thumbs]');
        var total = shots.length;
        var cur = 0;
        function pad(n) { return (n < 9 ? '0' : '') + (n + 1); }
        function show(i) {
          if (!total) return;
          if (i < 0) i = total - 1;
          if (i >= total) i = 0;
          cur = i;
          shots.forEach(function (s, idx) {
            if (idx === i && s.dataset.bxShotSrc && !s.getAttribute('src')) s.setAttribute('src', s.dataset.bxShotSrc);
            s.classList.toggle('bx-shot--on', idx === i);
          });
          thumbs.forEach(function (t, idx) {
            var on = idx === i;
            t.classList.toggle('hero-thumbs__btn--on', on);
            t.classList.toggle('hero-thumbs__btn--off', !on);
            if (on && track) {
              var tl = t.offsetLeft, tr = tl + t.offsetWidth;
              if (tl < track.scrollLeft) track.scrollTo({ left: tl - 2, behavior: 'smooth' });
              else if (tr > track.scrollLeft + track.clientWidth) track.scrollTo({ left: tr - track.clientWidth + 2, behavior: 'smooth' });
            }
          });
          dots.forEach(function (d, idx) { d.classList.toggle('hero-thumbs__dot--on', idx === i); });
          if (countEl) countEl.textContent = pad(i) + ' / ' + pad(total - 1);
        }
        thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.bxThumb, 10)); }); });
        var prev = root.querySelector('[data-bx-prev]');
        var next = root.querySelector('[data-bx-next]');
        if (prev) prev.addEventListener('click', function () { show(cur - 1); });
        if (next) next.addEventListener('click', function () { show(cur + 1); });
        /* thumbnail edge arrows page the rail by ~5 thumbs */
        var tPrev = root.querySelector('[data-bx-thumb-prev]'), tNext = root.querySelector('[data-bx-thumb-next]');
        function pageThumbs(dir) { if (track) track.scrollBy({ left: dir * 5 * 74, behavior: 'smooth' }); }
        if (tPrev) tPrev.addEventListener('click', function () { pageThumbs(-1); });
        if (tNext) tNext.addEventListener('click', function () { pageThumbs(1); });

        /* ----- offers (accordion) + flavor quantity steppers ----- */
        var offers = root.querySelectorAll('[data-po-offer]');
        var cta = root.querySelector('[data-po-cta]');

        function offerTotal(offer) {
          var t = 0;
          offer.querySelectorAll('.po2fl').forEach(function (r) { t += parseInt(r.dataset.count || '0', 10); });
          return t;
        }
        function renderOffer(offer) {
          var boxes = parseInt(offer.dataset.poBoxes, 10);
          var t = offerTotal(offer);
          offer.querySelectorAll('.po2fl').forEach(function (r) {
            var c = parseInt(r.dataset.count || '0', 10);
            var dec = r.querySelector('[data-po-dec]'), val = r.querySelector('[data-po-val]'), inc = r.querySelector('[data-po-inc]');
            if (val) { val.textContent = c; val.hidden = c === 0; }
            if (dec) dec.hidden = c === 0;
            if (inc) inc.disabled = t >= boxes;
            r.classList.toggle('po2fl--active', c > 0);
          });
          var picked = offer.querySelector('[data-po-picked]');
          if (picked) picked.textContent = t;
        }
        function updateCTA() {
          if (!cta) return;
          var open = root.querySelector('.po2off--on');
          if (!open) { cta.disabled = true; return; }
          var boxes = parseInt(open.dataset.poBoxes, 10);
          var remaining = boxes - offerTotal(open);
          if (remaining <= 0) { cta.disabled = false; cta.textContent = 'Continue'; }
          else { cta.disabled = true; cta.textContent = 'Add ' + remaining + (remaining === 1 ? ' box' : ' boxes'); }
        }
        function selectOffer(offer) {
          offers.forEach(function (o) { o.classList.toggle('po2off--on', o === offer); });
          updateCTA();
        }
        offers.forEach(function (offer) {
          var boxes = parseInt(offer.dataset.poBoxes, 10);
          var head = offer.querySelector('[data-po-offer-select]');
          if (head) head.addEventListener('click', function () { selectOffer(offer); });
          offer.querySelectorAll('.po2fl').forEach(function (r) {
            var inc = r.querySelector('[data-po-inc]'), dec = r.querySelector('[data-po-dec]');
            if (inc) inc.addEventListener('click', function (e) {
              e.stopPropagation();
              if (offerTotal(offer) >= boxes) return;
              r.dataset.count = String(parseInt(r.dataset.count || '0', 10) + 1);
              renderOffer(offer); updateCTA();
            });
            if (dec) dec.addEventListener('click', function (e) {
              e.stopPropagation();
              var c = parseInt(r.dataset.count || '0', 10);
              if (c > 0) { r.dataset.count = String(c - 1); renderOffer(offer); updateCTA(); }
            });
          });
          renderOffer(offer);
        });
        updateCTA();

        /* ----- Continue -> build cart-bridge URL -----
           Flavor boxes ride the offer's selling plan. The 4 free gifts are added one-time
           (no plan segment) unless data-po-gift-plan is set, in which case they ride that
           "Freebies Subscription" plan so they recur with the order. cart-bridge clears the
           cart, re-adds, checks out. */
        if (cta) cta.addEventListener('click', function () {
          if (cta.disabled) return;
          var open = root.querySelector('.po2off--on');
          if (!open) return;
          var plan = open.getAttribute('data-po-plan');
          var items = [];
          open.querySelectorAll('.po2fl').forEach(function (r) {
            var c = parseInt(r.dataset.count || '0', 10);
            var v = r.getAttribute('data-po-variant');
            if (c > 0 && v) items.push(v + ':' + c + (plan ? ':' + plan : ''));
          });
          if (!items.length) return;
          var offersEl = root.querySelector('[data-po-offers]');
          var gifts = ((offersEl && offersEl.getAttribute('data-po-gifts')) || '').split(',').filter(Boolean);
          var giftPlan = (offersEl && offersEl.getAttribute('data-po-gift-plan')) || '';
          gifts.forEach(function (g) { items.push(g + ':1' + (giftPlan ? ':' + giftPlan : '')); });
          window.location.href = '/pages/cart-bridge#items=' + items.join(',');
        });

        /* nutrition overlay is opened by the biome-nutrition-shake snippet's own
           global [data-bx-nutrition] listener - no handler needed here. */
      }

      function boot() { document.querySelectorAll('[data-po-root]').forEach(initPO2); }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-partner-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-po-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-po-copy');
        try { navigator.clipboard.writeText(code); } catch (e) {}
        btn.classList.add('po-voucher__copy--done');
        setTimeout(function () { btn.classList.remove('po-voucher__copy--done'); }, 2000);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-partners-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      root.querySelectorAll('[data-bx-faq]').forEach(function (item) {
        function toggle() { item.classList.toggle('faq__item--open'); }
        item.addEventListener('click', toggle);
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      });
    }
    function boot() { document.querySelectorAll('[data-bx-partners-faq]').forEach(initFaq); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(n) {
      var v = Math.round(Number(n) * 100) / 100;
      return Number.isInteger(v) ? String(v) : v.toFixed(2);
    }
    function initPdp(root) {
      var cfgEl = root.querySelector('[data-bx-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

      var base = cfg.base, sub = cfg.subDiscount, vol2 = cfg.vol2, vol3 = cfg.vol3;
      var MEALS = cfg.mealsPerBox, FREE = cfg.freeShipMin;
      var ONCE = [base, base - vol2, base - vol3];
      var SUB = [base - sub, base - vol2 - sub, base - vol3 - sub];
      var PACK_BOXES = 2, PACK_MEALS = 2 * MEALS;
      var PACK_RRP = 2 * base;   // starter pack RRP (2 boxes at full price) — the strike-through baseline

      function tierIndex(tb) { return tb >= 3 ? 2 : (tb >= 2 ? 1 : 0); }
      function calc(q, plan) {
        var starter = q.starter || 0;
        var flav = (q.vanilla || 0) + (q.chocolate || 0);
        var tb = flav + starter * PACK_BOXES;
        var tier = tierIndex(tb);
        var ppb = (plan === 'sub' ? SUB : ONCE)[tier];
        var starterUnit = ppb * PACK_BOXES;   // 2 boxes at the live tier — matches the cart's reconciled price
        var subtotal = ppb * flav + starterUnit * starter;
        var baseSubtotal = ONCE[0] * flav + PACK_RRP * starter;
        var meals = flav * MEALS + starter * PACK_MEALS;
        var ppm = meals > 0 ? subtotal / meals : (plan === 'sub' ? SUB : ONCE)[0] / MEALS;
        return { tb: tb, tier: tier, subtotal: subtotal, baseSubtotal: baseSubtotal,
                 savings: baseSubtotal - subtotal, meals: meals, ppm: ppm,
                 freeShip: subtotal >= FREE };
      }
      function blendedPerBox(q, plan) {
        var starter = q.starter || 0, flav = (q.vanilla || 0) + (q.chocolate || 0);
        var tb = flav + starter * PACK_BOXES;
        if (tb === 0) return (plan === 'sub' ? SUB : ONCE)[0];
        var ppb = (plan === 'sub' ? SUB : ONCE)[tierIndex(tb)];
        var pack = ppb * PACK_BOXES;
        return (ppb * flav + pack * starter) / tb;
      }
      function blendedPerMeal(q, plan) {
        var starter = q.starter || 0, flav = (q.vanilla || 0) + (q.chocolate || 0);
        var meals = flav * MEALS + starter * PACK_MEALS;
        if (meals === 0) return (plan === 'sub' ? SUB : ONCE)[0] / MEALS;
        var tb = flav + starter * PACK_BOXES;
        var ppb = (plan === 'sub' ? SUB : ONCE)[tierIndex(tb)];
        var pack = ppb * PACK_BOXES;
        return (ppb * flav + pack * starter) / meals;
      }
      function baselinePerBox(q) {
        var starter = q.starter || 0, flav = (q.vanilla || 0) + (q.chocolate || 0);
        var tb = flav + starter * PACK_BOXES;
        if (tb === 0) return ONCE[0];
        return (ONCE[0] * flav + PACK_RRP * starter) / tb;
      }

      var state = { qty: { vanilla: 0, chocolate: 0, starter: 0 }, plan: cfg.defaultPlan === 'once' ? 'once' : 'sub', freq: 2 };

      function businessEta(n) {
        var d = new Date(); var added = 0;
        while (added < n) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
        return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      }

      // The milestone bar is built ONCE then updated in place — replacing its
      // innerHTML every render would destroy the .ms-twin__fill element and kill
      // its `transition: width 0.4s` (the fill would jump instead of sliding).
      // Static structure/labels live in the skeleton; dynamic widths/colours are
      // set on the persistent nodes so the CSS transition animates.
      function buildMilestone() {
        // Simple buy-box (superfood template): swap the free-shipping progress bar for a
        // free-gift nudge keyed off the bonus threshold. No shipping copy at all.
        if (cfg.simpleBuybox) {
          // Visual gift-unlock tracker: a progress bar with two milestone points (1 + 2 boxes),
          // each tied to a free gift, that fills as boxes are added. The reward logic is unchanged
          // (both gifts land at the bonus threshold); the bar is the visualization the design calls for.
          var giftParts = (cfg.giftNames || '15-Day Challenge + Weight-Loss Guide').split(' + ');
          var g1 = giftParts[0] || 'Free gift', g2 = giftParts[1] || giftParts[0] || 'Free gift';
          return '' +
            '<div class="bx-gu" data-gn-root>' +
              '<div class="bx-gu__head">' +
                '<span class="bx-gu__ico" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 20 20" fill="none"><path d="M3 8h14v9H3zM2 5.5h16V8H2zM10 5.5V17M10 5.5C10 4 8.8 2.6 7.3 2.6 6.3 2.6 5.7 3.3 5.7 4.1 5.7 5.1 6.7 5.5 10 5.5zM10 5.5c0-1.5 1.2-2.9 2.7-2.9 1 0 1.6.7 1.6 1.5 0 1-1 1.4-4.3 1.4z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg></span>' +
                '<span class="bx-gu__txt" data-gn-txt></span>' +
              '</div>' +
              '<div class="bx-gu__track">' +
                '<span class="bx-gu__rail"></span>' +
                '<span class="bx-gu__fill" data-gn-fill></span>' +
                '<span class="bx-gu__pt" style="left:50%" data-gn-pt1><span class="bx-gu__pt-n">1</span><span class="bx-gu__pt-tick" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3 3 7-7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></span>' +
                '<span class="bx-gu__pt" style="left:100%" data-gn-pt2><span class="bx-gu__pt-n">2</span><span class="bx-gu__pt-tick" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3 3 7-7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></span>' +
              '</div>' +
              '<div class="bx-gu__labels">' +
                '<span class="bx-gu__lbl" data-gn-lbl1>' + g1 + '</span>' +
                '<span class="bx-gu__lbl" data-gn-lbl2>' + g2 + '</span>' +
              '</div>' +
            '</div>';
        }
        var sav1 = (ONCE[0] - ONCE[1]).toFixed(0), sav2 = (ONCE[0] - ONCE[2]).toFixed(0);
        return '' +
          '<div class="ms-twin" data-ms-root>' +
            '<div class="ms-twin__bar ms-twin__bar--tall" data-ms-bar>' +
              '<div class="ms-twin__fill" data-ms-fill></div>' +
              '<span class="ms-twin__inside" data-ms-inside>' +
                '<span class="ms-twin__inside-icon"><svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M1 4.5h8v6.5H1zM9 6.5h2.7l2.3 2.3v2.2H9z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="4" cy="12.5" r="1.4" fill="currentColor"/><circle cx="12" cy="12.5" r="1.4" fill="currentColor"/></svg></span>' +
                '<span data-ms-shiptext></span>' +
              '</span>' +
              '<span class="ms-twin__dot" style="left:0%" data-ms-dot0></span>' +
              '<span class="ms-twin__dot" style="left:100%" data-ms-dot100></span>' +
            '</div>' +
            '<div class="ms-twin__row ms-twin__row--bot">' +
              '<span class="ms-twin__marker ms-twin__marker--l" style="left:0%"><span class="ms-twin__marker-qty" data-ms-mk0>1 Unit</span></span>' +
              '<span class="ms-twin__marker" style="left:50%"><span class="ms-twin__marker-qty" data-ms-mk50q>2</span><span class="ms-twin__marker-perk" data-ms-mk50p>−$' + sav1 + '<span class="ms-twin__marker-perk-unit"> / unit</span></span></span>' +
              '<span class="ms-twin__marker ms-twin__marker--r" style="left:100%"><span class="ms-twin__marker-qty" data-ms-mk100q>3+</span><span class="ms-twin__marker-perk" data-ms-mk100p>−$' + sav2 + '<span class="ms-twin__marker-perk-unit"> / unit</span></span></span>' +
            '</div>' +
          '</div>';
      }
      function cacheMsEls() {
        var q = function (s) { return els.ms.querySelector(s); };
        els.msEls = {
          root: q('[data-ms-root]'), bar: q('[data-ms-bar]'), fill: q('[data-ms-fill]'),
          inside: q('[data-ms-inside]'), shiptext: q('[data-ms-shiptext]'),
          dot0: q('[data-ms-dot0]'), dot100: q('[data-ms-dot100]'),
          mk0: q('[data-ms-mk0]'), mk50q: q('[data-ms-mk50q]'), mk50p: q('[data-ms-mk50p]'),
          mk100q: q('[data-ms-mk100q]'), mk100p: q('[data-ms-mk100p]'),
          gnRoot: q('[data-gn-root]'), gnTxt: q('[data-gn-txt]'),
          gnFill: q('[data-gn-fill]'), gnPt1: q('[data-gn-pt1]'), gnPt2: q('[data-gn-pt2]')
        };
      }
      function setDot(el, reached, accent, tier) {
        var c = reached ? (accent || (tier === 2 ? 'var(--terracotta)' : 'var(--forest)')) : 'var(--cream-2)';
        var b = reached ? (accent || (tier === 2 ? 'var(--terracotta)' : 'var(--forest)')) : 'var(--sage)';
        el.style.background = c; el.style.borderColor = b;
      }
      function updateMilestone(t) {
        var ms = els.msEls; if (!ms) return;
        if (cfg.simpleBuybox) {
          if (!ms.gnRoot) return;
          var thr = cfg.bonusThreshold || 2;
          var boxes = t.tb || 0;
          var reached2 = boxes >= thr;
          var reached1 = boxes >= 1;
          // fill the rail toward the 2-box milestone
          var pct = Math.min(boxes, thr) / thr * 100;
          if (ms.gnFill) ms.gnFill.style.width = pct + '%';
          if (ms.gnPt1) ms.gnPt1.classList.toggle('bx-gu__pt--on', reached1);
          if (ms.gnPt2) ms.gnPt2.classList.toggle('bx-gu__pt--on', reached2);
          ms.gnRoot.classList.toggle('bx-gu--on', reached2);
          if (reached2) {
            ms.gnTxt.innerHTML = '<strong>2 free gifts unlocked!</strong>';
          } else if (reached1) {
            ms.gnTxt.innerHTML = '<strong>1 free gift unlocked</strong> - add 1 more box for your 2nd';
          } else {
            ms.gnTxt.innerHTML = 'Add <strong>1 box</strong> to unlock your first free gift';
          }
          return;
        }
        var pct = t.tb === 0 ? 0 : (t.tb === 1 ? 37.5 : (t.tb === 2 ? 87.5 : 100));
        var fillColor = t.tier === 2 ? 'var(--terracotta)' : 'var(--forest)';
        ms.root.classList.toggle('ms-twin--all-full', t.tier === 2);
        ms.bar.style.setProperty('--ms-pct', pct + '%');
        ms.fill.style.width = pct + '%';
        ms.fill.style.background = fillColor;
        ms.fill.classList.toggle('ms-twin__fill--full', pct >= 100);
        ms.inside.classList.toggle('ms-twin__inside--on', t.freeShip);
        ms.shiptext.textContent = t.freeShip ? 'Free shipping unlocked' : 'Free shipping at $' + FREE;
        setDot(ms.dot0, t.tb >= 1, null, t.tier);
        setDot(ms.dot100, t.tier === 2, 'var(--terracotta)', t.tier);
        ms.mk0.style.color = t.tb >= 1 ? 'var(--ink)' : 'var(--ink-2)';
        ms.mk50q.style.color = t.tb >= 2 ? 'var(--ink)' : 'var(--ink-2)';
        ms.mk50p.style.color = t.tb >= 2 ? 'var(--forest)' : 'var(--sage)';
        ms.mk100q.style.color = t.tier === 2 ? 'var(--ink)' : 'var(--ink-2)';
        ms.mk100p.style.color = t.tier === 2 ? 'var(--terracotta-2)' : 'var(--sage)';
      }

      var els = {
        rows: root.querySelectorAll('[data-bx-row]'),
        subPpm: root.querySelector('[data-bx-sub-ppm]'),
        subPpb: root.querySelector('[data-bx-sub-ppb]'),
        oncePpm: root.querySelector('[data-bx-once-ppm]'),
        oncePpb: root.querySelector('[data-bx-once-ppb]'),
        mealsTotal: root.querySelector('[data-bx-meals-total]'),
        cadence: root.querySelector('[data-bx-cadence]'),
        eta: root.querySelector('[data-bx-eta]'),
        atc: root.querySelector('[data-bx-atc]'),
        ms: root.querySelector('[data-bx-ms]'),
        freq: root.querySelector('[data-bx-freq]'),
        planSub: root.querySelector('[data-bx-plan="sub"]'),
        planOnce: root.querySelector('[data-bx-plan="once"]'),
        satc: root.querySelector('[data-bx-satc]'),
        satcTitle: root.querySelector('[data-bx-satc-title]'),
        satcSub: root.querySelector('[data-bx-satc-sub]'),
        satcPrice: root.querySelector('[data-bx-satc-price]'),
        satcThumb: root.querySelector('[data-bx-satc-thumb]'),
        satcBtn: root.querySelector('[data-bx-satc-btn]'),
        satcLabel: root.querySelector('[data-bx-satc-label]'),
        // Header smart-ATC (compact nav) lives outside this section — query the document.
        navAtcLabel: document.querySelector('[data-bx-navatc-label]'),
        navAtcTitle: document.querySelector('[data-bx-navatc-title]'),
        navAtcStrike: document.querySelector('[data-bx-navatc-strike]'),
        navAtcNum: document.querySelector('[data-bx-navatc-num]')
      };

      function render() {
        var t = calc(state.qty, state.plan);
        // flavor rows + steppers
        els.rows.forEach(function (row) {
          var id = row.getAttribute('data-bx-row');
          var n = state.qty[id] || 0;
          row.classList.toggle('flavor-row--on', n > 0);
          row.classList.toggle('flavor-row--empty', n === 0);
          var stepper = row.querySelector('[data-bx-stepper]');
          stepper.classList.toggle('stepper--collapsed', n === 0);
          var dec = row.querySelector('[data-bx-dec]'); var val = row.querySelector('[data-bx-val]');
          val.textContent = n; val.hidden = n === 0; dec.hidden = n === 0;
        });
        // plan prices
        var subPpb = blendedPerBox(state.qty, 'sub'), oncePpb = blendedPerBox(state.qty, 'once');
        var basePpb = baselinePerBox(state.qty);
        els.subPpm.textContent = '$' + fmt(blendedPerMeal(state.qty, 'sub')) + ' / meal';
        els.oncePpm.textContent = '$' + fmt(blendedPerMeal(state.qty, 'once')) + ' / meal';
        els.subPpb.innerHTML = '<span class="pln__pricecol-num pln__pricecol-num--sale"><span class="pln__pricecol-strike">$' + fmt(oncePpb) + '</span>$' + fmt(subPpb) + '<span class="pln__pricecol-unit">/ box</span></span>';
        var showStrike = basePpb > oncePpb + 0.01;
        els.oncePpb.innerHTML = '<span class="pln__pricecol-num ' + (showStrike ? 'pln__pricecol-num--sale' : '') + '">' + (showStrike ? '<span class="pln__pricecol-strike">$' + fmt(basePpb) + '</span>' : '') + '$' + fmt(oncePpb) + '<span class="pln__pricecol-unit">/ box</span></span>';
        // plan selected state
        els.planSub.classList.toggle('pln--on', state.plan === 'sub');
        els.planOnce.classList.toggle('pln--on', state.plan === 'once');
        // meals total + cadence + freq
        els.mealsTotal.textContent = t.meals > 0 ? (t.meals + ' MEALS TOTAL') : '';
        if (els.freq) { els.freq.value = String(state.freq); els.freq.dispatchEvent(new CustomEvent('flipdd:sync')); }
        if (els.cadence) els.cadence.textContent = t.meals > 0 ? ('≈ ' + (t.meals / (state.freq * 7)).toFixed(1) + ' meals / day') : '≈ 1 meal / day';
        // eta
        var etaStr = businessEta(3);
        els.eta.innerHTML = state.plan === 'sub'
          ? '1st delivery <strong class="bx-eta-strong">' + etaStr + '</strong> then every ' + state.freq + ' weeks'
          : 'Estimated delivery: <strong class="bx-eta-strong">' + etaStr + '</strong>';
        // ATC
        if (t.tb === 0) {
          els.atc.className = 'btn btn--lg btn--block btn--disabled';
          els.atc.disabled = true;
          els.atc.innerHTML = '<span class="bx-flex-center">Choose a flavor to continue</span>';
        } else {
          els.atc.className = 'btn btn--lg btn--block btn--primary';
          els.atc.disabled = false;
          els.atc.innerHTML = '<span class="bx-flex-left">Add ' + t.tb + ' ' + (t.tb === 1 ? 'box' : 'boxes') + ' · $' + fmt(t.ppm) + '/meal</span>' +
            '<span class="bx-atc-pricegrp">' +
            (t.savings > 0 ? '<span class="bx-atc-strike">$' + fmt(t.baseSubtotal) + '</span>' : '') +
            '<span class="bx-atc-total">$' + fmt(t.subtotal) + '</span></span>';
        }
        if (!els.msEls) { els.ms.innerHTML = buildMilestone(); cacheMsEls(); }
        updateMilestone(t);
        if (els.satc) {
          els.satcThumb.textContent = '14×' + (t.tb || '—');
          els.satcTitle.textContent = t.tb === 0 ? 'Weight-Loss Superfood Meal' : (t.tb + ' ' + (t.tb === 1 ? 'box' : 'boxes') + ' · ' + (t.tb * MEALS) + ' meals');
          els.satcSub.textContent = (state.plan === 'sub' ? 'Subscribe & save $' + cfg.subDiscount + '/box' : 'One-time purchase') + ((t.freeShip && !cfg.simpleBuybox) ? ' · free shipping' : '');
          els.satcPrice.textContent = '$' + fmt(t.tb ? t.subtotal : (state.plan === 'sub' ? SUB : ONCE)[0]);
          if (els.satcLabel) els.satcLabel.textContent = t.tb ? 'Add to cart' : 'Select a flavor';
        }
        // nav smart-ATC (header, compact mode) — same source of truth as the hero
        if (els.navAtcLabel) {
          if (t.tb === 0) {
            els.navAtcLabel.textContent = 'Your selection';
            els.navAtcTitle.textContent = 'Choose a flavor';
            if (els.navAtcStrike) els.navAtcStrike.hidden = true;
            els.navAtcNum.textContent = '—';
          } else {
            els.navAtcLabel.textContent = t.tb + ' ' + (t.tb === 1 ? 'box' : 'boxes') + ' · ' + (state.plan === 'sub' ? 'Subscribe' : 'One-time');
            els.navAtcTitle.textContent = (t.tb * MEALS) + ' meals · $' + fmt(t.ppm) + '/meal';
            if (els.navAtcStrike) {
              if (t.savings > 0) { els.navAtcStrike.hidden = false; els.navAtcStrike.textContent = '$' + fmt(t.baseSubtotal); }
              else els.navAtcStrike.hidden = true;
            }
            els.navAtcNum.textContent = '$' + fmt(t.subtotal);
          }
        }
      }

      function setQty(id, n) {
        state.qty[id] = Math.max(0, n);
        var tb = (state.qty.vanilla || 0) + (state.qty.chocolate || 0) + (state.qty.starter || 0) * PACK_BOXES;
        state.freq = Math.min(12, Math.max(2, (tb || 1) * 2));
        state.freqManual = false;        // qty changed → auto cadence wins again
        render();
      }

      els.rows.forEach(function (row) {
        var id = row.getAttribute('data-bx-row');
        row.querySelector('[data-bx-inc]').addEventListener('click', function (e) { e.stopPropagation(); setQty(id, (state.qty[id] || 0) + 1); });
        row.querySelector('[data-bx-dec]').addEventListener('click', function (e) { e.stopPropagation(); setQty(id, (state.qty[id] || 0) - 1); });
        row.addEventListener('click', function () { if ((state.qty[id] || 0) === 0) setQty(id, 1); });
      });
      // Whole plan card is the select target (delegated). Guard real form controls so the
      // frequency <select> still opens without re-selecting the plan.
      root.addEventListener('click', function (e) {
        if (e.target.closest('select, input, option')) return;
        var planSel = e.target.closest('[data-bx-plan-select]');
        if (planSel) { state.plan = planSel.getAttribute('data-bx-plan-select'); render(); }
      });
      if (els.freq) els.freq.addEventListener('change', function () { state.freq = Number(els.freq.value); state.freqManual = true; render(); });

      // ATC → (first-time partner nudge) → AJAX add
      function commitAdd() {
        var t = calc(state.qty, state.plan);
        if (t.tb === 0) return;
        var vanQty = (state.qty.vanilla || 0) + (state.qty.starter || 0);
        var chocQty = (state.qty.chocolate || 0) + (state.qty.starter || 0);
        var props = { _plan: state.plan, _tier_boxes: String(t.tb) };
        if (state.plan === 'sub') props._delivery_weeks = String(state.freq);
        var items = [];
        // When a real Appstle selling plan is configured, attach it to subscribe lines so the
        // subscription is applied at add time (the cart drawer leaves these variants untouched).
        // Pick the Appstle plan that matches the auto cadence (boxes x 2 weeks); fall back to the
        // configured plan id. subPlans is only populated when a product override is set.
        var sp = null;
        if (state.plan === 'sub') { sp = (cfg.subPlans && cfg.subPlans[state.freq]) || cfg.subPlanId || null; }
        if (vanQty > 0 && cfg.variants.vanilla) { var iv = { id: cfg.variants.vanilla, quantity: vanQty, properties: props }; if (sp) iv.selling_plan = sp; items.push(iv); }
        if (chocQty > 0 && cfg.variants.chocolate) { var ic = { id: cfg.variants.chocolate, quantity: chocQty, properties: props }; if (sp) ic.selling_plan = sp; items.push(ic); }
        // Free gifts ($0 digital products, one-time — no selling plan so they don't recur), matching
        // the gift-unlock bar: gift 1 at 1 box, gift 2 at the bonus threshold. Only added when the
        // gift variant ids are configured (superfood PDP), so other products stay unchanged.
        var giftThr = cfg.bonusThreshold || 2;
        if (cfg.gift1 && t.tb >= 1) items.push({ id: cfg.gift1, quantity: 1, properties: { _free_gift: 'true' } });
        if (cfg.gift2 && t.tb >= giftThr) items.push({ id: cfg.gift2, quantity: 1, properties: { _free_gift: 'true' } });
        if (!items.length) return;
        els.atc.disabled = true;
        if (cfg.directCheckout) {
          // Skip the cart drawer — add the line(s) then go straight to checkout.
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { window.location.href = '/checkout'; })
            .catch(function () { els.atc.disabled = false; });
        } else if (window.BiomeCart && window.BiomeCart.addAndOpen) {
          window.BiomeCart.addAndOpen(items, { plan: state.plan, freq: state.freq, freqManual: state.freqManual })
            .then(function () { els.atc.disabled = false; })
            .catch(function () { els.atc.disabled = false; });
        } else {
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { window.location.href = '/cart'; })
            .catch(function () { els.atc.disabled = false; });
        }
      }
      function nudgeSeen() { return /(?:^|; )biome_partner_nudge_seen=1(?:;|$)/.test(document.cookie || ''); }
      function markNudgeSeen() { try { document.cookie = 'biome_partner_nudge_seen=1; max-age=' + (60 * 60 * 24 * 365) + '; path=/; samesite=lax'; } catch (e) {} }
      var pn = root.querySelector('[data-bx-nudge]');
      var pnBack = root.querySelector('[data-bx-nudge-back]');
      function openNudge() {
        if (!pn) { commitAdd(); return; }
        var soloPpb = blendedPerBox(state.qty, state.plan);
        var dbl = { vanilla: (state.qty.vanilla || 0) * 2, chocolate: (state.qty.chocolate || 0) * 2, starter: (state.qty.starter || 0) * 2 };
        var sav = Math.max(0, Math.round((soloPpb - blendedPerBox(dbl, state.plan)) * 100) / 100);
        var savEl = root.querySelector('[data-bx-nudge-sav]');
        if (savEl) savEl.innerHTML = sav > 0 ? ('and <b>save $' + fmt(sav) + ' more per box</b> from the bigger-bundle discount.') : 'and unlock the next bigger-bundle discount.';
        pn.classList.add('pn--open'); pn.setAttribute('aria-hidden', 'false');
        if (pnBack) pnBack.classList.add('pn-back--open');
        document.body.style.overflow = 'hidden';
      }
      function closeNudge() { if (pn) { pn.classList.remove('pn--open'); pn.setAttribute('aria-hidden', 'true'); } if (pnBack) pnBack.classList.remove('pn-back--open'); document.body.style.overflow = ''; }
      function nudgeSolo() { markNudgeSeen(); closeNudge(); commitAdd(); }
      function nudgePartner() {
        markNudgeSeen(); closeNudge();
        state.qty = { vanilla: (state.qty.vanilla || 0) * 2, chocolate: (state.qty.chocolate || 0) * 2, starter: (state.qty.starter || 0) * 2 };
        state.freq = Math.min(12, state.freq * 2);   // 2× the basket → 2× the cadence
        render(); commitAdd();
      }
      els.atc.addEventListener('click', function () {
        if (calc(state.qty, state.plan).tb === 0) return;
        if (nudgeSeen()) commitAdd(); else openNudge();
      });
      root.querySelectorAll('[data-bx-nudge-solo]').forEach(function (b) { b.addEventListener('click', nudgeSolo); });
      root.querySelectorAll('[data-bx-nudge-partner]').forEach(function (b) { b.addEventListener('click', nudgePartner); });
      if (pnBack) pnBack.addEventListener('click', nudgeSolo);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pn && pn.classList.contains('pn--open')) nudgeSolo(); });

      // sticky ATC — reuse the hero ATC handler; surface on scroll past the buy-box
      if (els.satcBtn) els.satcBtn.addEventListener('click', function () {
        if (calc(state.qty, state.plan).tb === 0) { var fp = document.getElementById('flavor-pick'); if (fp) fp.scrollIntoView({ behavior: 'smooth' }); }
        else { els.atc.click(); }
      });
      var heroAtc = root.querySelector('.atcw');
      function onSatcScroll() {
        if (!els.satc) return;
        var past = heroAtc ? heroAtc.getBoundingClientRect().bottom < 0 : false;
        var fin = document.querySelector('footer.footer');
        var atEnd = fin ? fin.getBoundingClientRect().top < (window.innerHeight + 40) : false;
        els.satc.classList.toggle('satc--show', past && !atEnd);
      }
      window.addEventListener('scroll', onSatcScroll, { passive: true });
      onSatcScroll();

      // rotating tagline
      var taglineEls = root.querySelectorAll('[data-bx-tagline]');
      var taglines = (cfgEl.getAttribute('data-taglines') || '').split('|').filter(Boolean);
      if (taglineEls.length && taglines.length > 1) {
        var ti = 0;
        setInterval(function () {
          taglineEls.forEach(function (el) { el.classList.add('bx-tagline--out'); });
          setTimeout(function () { ti = (ti + 1) % taglines.length; taglineEls.forEach(function (el) { el.textContent = taglines[ti]; el.classList.remove('bx-tagline--out'); }); }, 320);
        }, 3200);
      }

      // gallery — main crossfade shots + thumbnails. Both desktop and mobile use a
      // horizontal scroll rail (swipe on touch / drag with a mouse). Desktop caps the
      // rail at 5 thumbs (CSS max-width) and keeps the flanking arrows, which page it.
      var shots = root.querySelectorAll('[data-bx-shot]');
      var thumbs = root.querySelectorAll('[data-bx-thumb]');
      var dots = root.querySelectorAll('[data-bx-dot]');
      var countEl = root.querySelector('[data-bx-count]');
      var track = root.querySelector('[data-bx-thumbs]');
      var tprev = root.querySelector('[data-bx-thumb-prev]'), tnext = root.querySelector('[data-bx-thumb-next]');
      var gi = 0;
      function loadShot(n) {
        var s = shots[n];
        if (s && !s.getAttribute('src') && s.getAttribute('data-bx-shot-src')) { s.setAttribute('src', s.getAttribute('data-bx-shot-src')); }
      }
      // Every thumb lives in the rail (no windowing); fade each thumb img in once it loads (no popping).
      thumbs.forEach(function (b) {
        b.hidden = false;
        var im = b.querySelector('img');
        if (im && !im.complete) { im.classList.add('is-fading'); var on = function () { im.classList.add('is-loaded'); }; im.addEventListener('load', on); im.addEventListener('error', on); }
      });
      // Enable/disable the flanking arrows based on how far the rail is scrolled.
      function syncArrows() {
        if (!track) return;
        var max = track.scrollWidth - track.clientWidth;
        if (tprev) tprev.disabled = track.scrollLeft <= 1;
        if (tnext) tnext.disabled = track.scrollLeft >= max - 1;
      }
      function pageBy(dir) {                                    // arrows scroll the rail by one visible page
        if (!track) return;
        var step = (thumbs.length > 1) ? (thumbs[1].offsetLeft - thumbs[0].offsetLeft) : 74;
        var per = Math.max(1, Math.round(track.clientWidth / step));
        track.scrollBy({ left: dir * per * step, behavior: 'smooth' });
      }
      function setShot(i, skipScroll) {
        if (!shots.length) return;
        var total = shots.length;
        gi = (i + total) % total;
        loadShot(gi); loadShot((gi + 1) % total); loadShot((gi - 1 + total) % total);
        shots.forEach(function (s, n) { s.classList.toggle('bx-shot--on', n === gi); });
        thumbs.forEach(function (b, n) {
          b.classList.toggle('hero-thumbs__btn--on', n === gi);
          b.classList.toggle('hero-thumbs__btn--off', n !== gi);
        });
        if (!skipScroll && thumbs[gi] && thumbs[gi].scrollIntoView) {          // keep the active thumb in view in the rail (not on init — would scroll the page to the gallery)
          thumbs[gi].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
        dots.forEach(function (d, n) { d.classList.toggle('hero-thumbs__dot--on', n === gi); });
        if (countEl) countEl.textContent = ('0' + (gi + 1)).slice(-2) + ' / ' + ('0' + total).slice(-2);
      }
      thumbs.forEach(function (b, n) { b.addEventListener('click', function () { setShot(n); }); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { setShot(n); }); });
      var prev = root.querySelector('[data-bx-prev]'), next = root.querySelector('[data-bx-next]');
      if (prev) prev.addEventListener('click', function () { setShot(gi - 1); });
      if (next) next.addEventListener('click', function () { setShot(gi + 1); });
      // Thumbnail arrows page the rail (desktop) — browse beyond the first five.
      if (tprev) tprev.addEventListener('click', function () { pageBy(-1); });
      if (tnext) tnext.addEventListener('click', function () { pageBy(1); });
      if (track) {
        track.addEventListener('scroll', syncArrows, { passive: true });
        window.addEventListener('resize', syncArrows);
        // Mouse: drag the rail to scroll. Move/up are bound to the window during a drag, so letting
        // go anywhere (even off the rail) reliably ends it. A press that doesn't move selects that
        // thumb on release (snap-proof — uses the thumb you pressed). Touch + keyboard use the
        // thumbs' own click handlers above.
        var down = false, sx = 0, sl = 0, moved = false, pressIdx = -1, ptrType = '', snapRAF = 0;
        function thumbStep() { return thumbs.length > 1 ? (thumbs[1].offsetLeft - thumbs[0].offsetLeft) : 74; }
        function gentleSnap(target) {                           // ease (decelerate) into the nearest thumb edge
          cancelAnimationFrame(snapRAF);
          var startL = track.scrollLeft, dist = target - startL, t0 = 0;
          if (Math.abs(dist) < 1) { track.classList.remove('is-dragging'); return; }
          function tick(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / 340);
            track.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));   // easeOutCubic
            if (p < 1) { snapRAF = requestAnimationFrame(tick); }
            else { track.classList.remove('is-dragging'); }
          }
          snapRAF = requestAnimationFrame(tick);
        }
        function onMove(e) {
          if (!down) return;
          var dx = e.clientX - sx;
          if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }   // a real drag has begun
          if (moved) track.scrollLeft = sl - dx;
        }
        function endDrag() {
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', endDrag);
          window.removeEventListener('pointercancel', endDrag);
          if (!down) return;
          down = false;
          if (moved) { gentleSnap(Math.round(track.scrollLeft / thumbStep()) * thumbStep()); }
          else { track.classList.remove('is-dragging'); if (pressIdx > -1) setShot(pressIdx); }    // a tap selects the pressed thumb
          pressIdx = -1;
        }
        track.addEventListener('pointerdown', function (e) {
          ptrType = e.pointerType;
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          var b = e.target.closest('[data-bx-thumb]');
          pressIdx = b ? Array.prototype.indexOf.call(thumbs, b) : -1;
          down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
          cancelAnimationFrame(snapRAF);                        // grabbing again interrupts an in-flight snap
          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', endDrag);
          window.addEventListener('pointercancel', endDrag);
        });
        // Mouse selection is handled on pointerup (endDrag) — swallow the synthetic mouse click so it
        // neither double-fires nor (after a drag) switches the shot. Touch/keyboard clicks pass through.
        track.addEventListener('click', function (e) { if (ptrType === 'mouse' && e.detail > 0) { e.preventDefault(); e.stopPropagation(); } }, true);
        // Block native image dragging so a drag that starts ON a thumb still scrolls the rail.
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      // Touch: swipe the hero image left/right to change the shot.
      function bxSwipe(el) {
        if (!el) return;
        var sx = 0, sy = 0, st = 0;
        el.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); }, { passive: true });
        el.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) < 36 || Math.abs(dx) <= Math.abs(dy) || Date.now() - st > 800) return;
          setShot(gi + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
      bxSwipe(root.querySelector('[data-bx-gallery]'));
      setShot(0, true); // init: skip the scrollIntoView (would yank the page to the gallery on load)
      syncArrows();

      render();
    }
    function boot() { document.querySelectorAll('[data-biome-pdp]').forEach(initPdp); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-rev-board"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PAGE = 5;

    function initBoard(root) {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rv-card]'));
      var filters = root.querySelectorAll('[data-rv-filter]');
      var sorts = root.querySelectorAll('[data-rv-sort]');
      var moreWrap = root.querySelector('[data-rv-more]');
      var moreBtn = root.querySelector('[data-rv-showmore]');
      var emptyEl = root.querySelector('[data-rv-empty]');
      var counts = root.querySelectorAll('[data-rv-count]');
      var stripWrap = root.querySelector('[data-rv-photostrip]');
      var stripRow = root.querySelector('[data-rv-photostrip-row]');

      var state = { filter: 'all', sort: 'recent', showCount: PAGE };

      // Live filter counts (per product) computed from the rendered cards.
      var totals = { all: cards.length, shake: 0, metab: 0, bloat: 0 };
      cards.forEach(function (c) {
        var p = c.getAttribute('data-product');
        if (totals[p] !== undefined) totals[p] += 1;
      });
      counts.forEach(function (el) {
        var key = el.getAttribute('data-rv-count');
        el.textContent = '(' + (totals[key] || 0) + ')';
      });

      // Build the top-of-board photo strip from the first 7 review photos.
      if (stripWrap && stripRow) {
        var imgs = [];
        cards.forEach(function (c) {
          c.querySelectorAll('.rv-card__photo img').forEach(function (img) {
            if (imgs.length < 7) imgs.push(img.getAttribute('src'));
          });
        });
        if (imgs.length > 0) {
          imgs.forEach(function (src) {
            var span = document.createElement('span');
            span.className = 'rv-photostrip__item';
            var im = document.createElement('img');
            im.src = src;
            im.alt = '';
            im.loading = 'lazy';
            span.appendChild(im);
            stripRow.appendChild(span);
          });
          stripWrap.hidden = false;
        }
      }

      function matches(card) {
        if (state.filter !== 'all' && card.getAttribute('data-product') !== state.filter) return false;
        if (state.sort === 'photos' && card.getAttribute('data-has-photos') !== 'true') return false;
        return true;
      }

      function render() {
        var shown = 0;
        var matchTotal = 0;
        cards.forEach(function (card) {
          if (matches(card)) {
            matchTotal += 1;
            if (shown < state.showCount) {
              card.hidden = false;
              shown += 1;
            } else {
              card.hidden = true;
            }
          } else {
            card.hidden = true;
          }
        });

        if (emptyEl) emptyEl.hidden = matchTotal !== 0;
        if (moreWrap) moreWrap.hidden = matchTotal <= state.showCount;
      }

      // Toggle chip classes with transitions suspended + a forced reflow, otherwise the
      // color/background transition freezes at its start value (the theme-wide stuck-
      // transition quirk) and the selected chip renders unreadable.
      function snapToggle(btns, apply) {
        btns.forEach(function (b) { b.style.transition = 'none'; });
        apply();
        void btns[0].offsetHeight;
        btns.forEach(function (b) { b.style.transition = ''; });
      }

      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.filter = btn.getAttribute('data-rv-filter');
          state.showCount = PAGE;
          snapToggle(filters, function () {
            filters.forEach(function (b) {
              var on = b === btn;
              b.classList.toggle('rv-filter--on', on);
              b.setAttribute('aria-selected', on ? 'true' : 'false');
            });
          });
          render();
        });
      });

      sorts.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.sort = btn.getAttribute('data-rv-sort');
          snapToggle(sorts, function () {
            sorts.forEach(function (b) {
              b.classList.toggle('rv-sort__opt--on', b === btn);
            });
          });
          render();
        });
      });

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          state.showCount += PAGE;
          render();
        });
      }

      render();
    }

    function boot() {
      document.querySelectorAll('[data-rv-board]').forEach(initBoard);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tagsMatch(el, filter) {
      if (filter === 'all') return true;
      var tags = (el.getAttribute('data-tags') || '').split(',');
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].trim() === filter) return true;
      }
      return false;
    }

    function initReviews(root) {
      var pills = root.querySelectorAll('[data-bs-filter]');
      var cards = root.querySelectorAll('[data-bs-card]');
      var empty = root.querySelector('[data-bs-empty]');
      var grid = root.querySelector('[data-bs-grid]');
      var prev = root.querySelector('[data-bs-prev]');
      var next = root.querySelector('[data-bs-next]');
      var state = { filter: (pills[0] && pills[0].getAttribute('data-bs-filter')) || 'all' };

      function updateArrows() {
        if (!grid || !prev || !next) return;
        var max = grid.scrollWidth - grid.clientWidth - 2;
        prev.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft >= max || max <= 0;
      }
      function step() {
        if (!grid) return 300;
        var card = grid.querySelector('[data-bs-card]:not([style*="display: none"])') || grid.querySelector('[data-bs-card]');
        return card ? card.getBoundingClientRect().width + 12 : 300;
      }
      function render() {
        var shown = 0;
        cards.forEach(function (el) {
          var ok = tagsMatch(el, state.filter);
          el.style.display = ok ? '' : 'none';
          if (ok) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
        if (grid) grid.scrollLeft = 0;
        updateArrows();
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          state.filter = pill.getAttribute('data-bs-filter');
          pills.forEach(function (p) { p.classList.remove('sk-rev__pill--on'); p.setAttribute('aria-selected', 'false'); });
          pill.classList.add('sk-rev__pill--on');
          pill.setAttribute('aria-selected', 'true');
          render();
        });
      });
      if (prev) prev.addEventListener('click', function () { grid.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function () { grid.scrollLeft += step(); });
      if (grid) grid.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);

      render();
    }

    function boot() { document.querySelectorAll('[data-bs-rev]').forEach(initReviews); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-sci-glycemic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    function arm(el) {
      var gentle = el.querySelector('.sci-curve__line--gentle');
      if (!gentle) return;
      // The gentle line is a continuous stroke — animate its full length.
      // The spike keeps its own "5 5" dasharray, so we only reveal the gentle
      // curve via dashoffset to avoid clobbering the spike's dashes.
      var len = 0;
      try { len = gentle.getTotalLength ? gentle.getTotalLength() : 0; } catch (e) { len = 0; }
      if (!len) return;
      gentle.style.strokeDasharray = len + ' ' + len;
      el.style.setProperty('--draw-len', len);
      el.setAttribute('data-armed', '');

      if (!('IntersectionObserver' in window)) {
        el.setAttribute('data-in', '');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            el.setAttribute('data-in', '');
            io.disconnect();
          }
        });
      }, { threshold: 0.35 });
      io.observe(el);
    }

    document.querySelectorAll('[data-sci-curve]').forEach(arm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-ugc-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pauseOtherVideos(el) {
      document.querySelectorAll('video').forEach(function (v) {
        if (v !== el && !v.paused) {
          try { v.pause(); } catch (_) {}
        }
      });
    }
    function fmtTime(sec) {
      if (!sec || !isFinite(sec)) return '0:00';
      var m = Math.floor(sec / 60);
      var s = Math.floor(sec % 60).toString();
      if (s.length < 2) s = '0' + s;
      return m + ':' + s;
    }
    function initUgcv(root) {
      var video = root.querySelector('[data-bs-video]');
      var stage = root.querySelector('[data-bs-stage]');
      var playBtn = root.querySelector('[data-bs-play]');
      var timeEl = root.querySelector('[data-bs-time]');
      var nameEl = root.querySelector('[data-bs-name]');
      var captionEl = root.querySelector('[data-bs-caption]');
      var beforeEl = root.querySelector('[data-bs-before]');
      var afterEl = root.querySelector('[data-bs-after]');
      var thumbs = root.querySelectorAll('[data-bs-thumb]');
      if (!video || !stage) return;

      var started = false;

      function updateOverlay() {
        // overlay shows when not started OR paused (mirrors prototype showOverlay)
        var show = !started || video.paused;
        if (playBtn) playBtn.hidden = !show;
      }

      // play() can be rejected when it races an in-flight load() (seen in
      // Firefox and some Chrome). Retry once the media reports it can play,
      // then fall back to the overlay so the poster + play button stay visible
      // instead of a blank frame.
      function playSafe() {
        var p;
        try { p = video.play(); } catch (e) { p = null; }
        if (p && p.catch) {
          p.catch(function () {
            var retry = function () {
              var p2;
              try { p2 = video.play(); } catch (e) { p2 = null; }
              if (p2 && p2.catch) p2.catch(function () { started = false; updateOverlay(); });
            };
            video.addEventListener('canplay', retry, { once: true });
          });
        }
      }

      function togglePlay() {
        if (!started) started = true;
        if (video.paused) {
          pauseOtherVideos(video);
          playSafe();
        } else {
          video.pause();
        }
      }

      function setActive(i) {
        var btn = thumbs[i];
        if (!btn) return;
        try { video.pause(); } catch (e) {}
        // Show the clip's poster (if it has one) the instant it's selected, so a
        // slow-to-decode clip displays its frame immediately instead of going
        // blank while it buffers. Clips without a poster fall back to the frame.
        var poster = btn.getAttribute('data-clip-poster');
        if (poster) { video.poster = poster; } else { video.removeAttribute('poster'); }
        // Append the #t=0.1 frame hint only when there's no poster — with a poster
        // set, the fragment's seek would override (hide) the poster image.
        video.src = btn.getAttribute('data-clip-video') + (poster ? '' : '#t=0.1');
        video.load();
        if (nameEl) nameEl.textContent = btn.getAttribute('data-clip-name') || '';
        if (captionEl) captionEl.textContent = btn.getAttribute('data-clip-caption') || '';
        if (beforeEl) beforeEl.textContent = btn.getAttribute('data-clip-before') || '';
        if (afterEl) afterEl.textContent = btn.getAttribute('data-clip-after') || '';
        if (timeEl) timeEl.textContent = '0:00 / 0:00';
        thumbs.forEach(function (b, n) { b.classList.toggle('bs-thumb--on', n === i); });
        // autoplay the newly selected clip (the thumb click is a user gesture,
        // so play() is permitted); playSafe handles a refused or raced play().
        started = true;
        pauseOtherVideos(video);
        playSafe();
        updateOverlay();
      }

      stage.addEventListener('click', togglePlay);
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePlay(); }
      });
      if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });

      video.addEventListener('loadedmetadata', function () {
        if (timeEl) timeEl.textContent = fmtTime(video.currentTime) + ' / ' + fmtTime(video.duration);
      });
      video.addEventListener('timeupdate', function () {
        if (timeEl) timeEl.textContent = fmtTime(video.currentTime) + ' / ' + fmtTime(video.duration);
      });
      video.addEventListener('play', updateOverlay);
      video.addEventListener('pause', updateOverlay);
      video.addEventListener('ended', function () {
        if (timeEl) timeEl.textContent = fmtTime(0) + ' / ' + fmtTime(video.duration);
        updateOverlay();
      });
      // If a source fails to load, drop back to the overlay (poster + play
      // button) rather than leaving a stuck, blank player.
      video.addEventListener('error', function () { started = false; updateOverlay(); });

      thumbs.forEach(function (b, n) {
        b.addEventListener('click', function () { setActive(n); });
      });

      // while the clip is playing, a click anywhere outside the player pauses
      // it — same effect as clicking the video itself. Thumbs are excluded so
      // their switch-and-autoplay behavior wins; capture phase so a
      // stopPropagation elsewhere can't swallow the click.
      document.addEventListener('click', function (e) {
        if (video.paused) return;
        if (stage.contains(e.target)) return;
        var withinThumb = false;
        thumbs.forEach(function (b) { if (b.contains(e.target)) withinThumb = true; });
        if (!withinThumb) video.pause();
      }, true);

      updateOverlay();
    }
    // Mobile: the clip picker is a horizontal swipe rail (see biome.css) that
    // auto-advances through the thumbs. It pauses on user touch/scroll, while
    // off-screen, and when the tab is hidden; respects reduced-motion.
    function initRail(root) {
      var rail = root.querySelector('.sk-rr__thumbs');
      if (!rail) return;
      var mq = window.matchMedia('(max-width: 760px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var timer = null, idle = null;

      function advance() {
        var items = rail.querySelectorAll('[data-bs-thumb]');
        if (items.length < 2) return;
        // near the end → wrap back to the start
        if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        // otherwise snap to the first tile whose left edge is past the rail's
        var railLeft = rail.getBoundingClientRect().left;
        for (var i = 0; i < items.length; i++) {
          var dx = items[i].getBoundingClientRect().left - railLeft;
          if (dx > 4) { rail.scrollTo({ left: rail.scrollLeft + dx, behavior: 'smooth' }); return; }
        }
      }
      function start() {
        if (timer || !mq.matches || reduce.matches) return;
        timer = setInterval(advance, 3200);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function bump() {
        // user interacted — hold, then resume after a beat of inactivity
        stop();
        if (idle) clearTimeout(idle);
        idle = setTimeout(start, 4500);
      }

      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        rail.addEventListener(ev, bump, { passive: true });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      if (mq.addEventListener) mq.addEventListener('change', function () { stop(); start(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { threshold: 0.25 }).observe(rail);
      } else {
        start();
      }
    }
    function boot() {
      document.querySelectorAll('[data-bs-ugcv]').forEach(function (root) {
        initUgcv(root);
        initRail(root);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-ugc-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pauseOtherVideos(el) {
      document.querySelectorAll('video').forEach(function (v) {
        if (v !== el && !v.paused) {
          try { v.pause(); } catch (_) {}
        }
      });
    }

    function initUgc(root) {
      var track = root.querySelector('[data-bs-ugc-track]');
      var wall = root.querySelector('.ugcwall');
      var cards = root.querySelectorAll('.ugcwall__card');
      if (!track || !wall) return;

      // ── Auto-marquee + swipe, via native horizontal scroll ──────────────────
      // The wall is overflow-x:auto (biome.css), so touch-swipe works natively and
      // the mouse drag-to-scroll below behaves like the hero-thumbs rail. rAF nudges
      // scrollLeft for the ambient marquee and seamlessly wraps at the halfway point
      // (the reels are doubled). We pause the auto motion while a clip plays OR while
      // the user is interacting (and briefly after, so momentum isn't fought). The CSS
      // transform marquee is disabled so the two don't fight.
      track.style.animation = 'none';
      var copies = parseInt(track.getAttribute('data-bs-ugc-copies'), 10) || 2;
      var perCopy = Math.max(1, Math.round(cards.length / copies));   // unique reels per copy
      var copyW = 0, lastTs = 0, scrollAcc = 0, videoPlaying = false, hovering = false, dragging = false, touchActive = false, idleTimer = null;
      function measure() {
        // Exact width of one copy = distance from card 0 to the first card of copy 2, so the
        // wrap is pixel-seamless at any viewport width (scrollWidth/copies is skewed by the
        // track's end padding).
        copyW = (cards.length > perCopy && cards[perCopy]) ? (cards[perCopy].offsetLeft - cards[0].offsetLeft) : (track.scrollWidth / copies);
      }
      measure();
      window.addEventListener('resize', measure);
      function frame(ts) {
        if (!copyW) measure();
        if (lastTs && copyW > 0 && !videoPlaying && !hovering && !dragging && !touchActive) {
          var dt = Math.min((ts - lastTs) / 1000, 0.05);              // cap so a backgrounded tab doesn't jump
          scrollAcc += (copyW / 80) * dt;                             // ~80s per copy; accumulate sub-pixels —
          var stepPx = scrollAcc | 0;                                 // iOS rounds scrollLeft, so apply whole px only
          if (stepPx) {
            scrollAcc -= stepPx;
            var nl = wall.scrollLeft + stepPx;
            if (nl >= copyW) nl -= copyW;                             // seamless wrap at one copy
            wall.scrollLeft = nl;
          }
        }
        lastTs = ts;
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);

      function syncPaused() {
        var any = false;
        root.querySelectorAll('.ugcwall__video').forEach(function (v) { if (!v.paused) any = true; });
        videoPlaying = any;   // freeze the auto-scroll while a clip is playing
      }

      // Desktop: pause the auto-scroll whenever the pointer is over the wall (the old CSS
      // :hover pause). Touch devices have no real hover, so they skip this.
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        wall.addEventListener('mouseenter', function () { hovering = true; });
        wall.addEventListener('mouseleave', function () { hovering = false; });
      }

      // Touch: pause while swiping + a short beat after, so native momentum isn't fought.
      wall.addEventListener('touchstart', function () { touchActive = true; if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; } }, { passive: true });
      function endTouch() { if (idleTimer) clearTimeout(idleTimer); idleTimer = setTimeout(function () { touchActive = false; }, 1600); }
      wall.addEventListener('touchend', endTouch, { passive: true });
      wall.addEventListener('touchcancel', endTouch, { passive: true });

      // Mouse drag-to-scroll (touch scrolls natively). `dragging` keeps the auto-scroll
      // paused even if the cursor slips off mid-drag; on release the hover state takes over
      // with NO cooldown (so it resumes the instant the cursor leaves the wall — no 1s
      // dead pause). A real drag swallows the trailing click so it doesn't toggle a video.
      var down = false, startX = 0, startLeft = 0, moved = false;
      wall.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; dragging = true; moved = false; startX = e.clientX; startLeft = wall.scrollLeft;
        wall.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        wall.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false; dragging = false; wall.classList.remove('is-dragging');
      });
      wall.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      wall.addEventListener('dragstart', function (e) { e.preventDefault(); });   // media-drag must not hijack the mouse drag

      // Posters are now STATIC images (the video's `poster=` attribute, set from a
      // CDN webp still) and the duration label is rendered server-side — so there's
      // no poster-priming JS at all. The old approach (preload→metadata + seek
      // currentTime=0.1 to paint a frame) decoded every clip just to show a still:
      // heavy, and the decodes all completed together so the stills popped in as one
      // batch. Static stills paint instantly + progressively as their 6 unique webps
      // load, the videos stay preload="none" until tapped, and the main thread stays
      // free for the marquee rAF. Don't reintroduce frame-seek posters.

      // ── Per-card play / pause ───────────────────────────────────────────────
      cards.forEach(function (card) {
        var video = card.querySelector('.ugcwall__video');
        if (!video) return;

        function toggle() {
          if (video.paused) {
            pauseOtherVideos(video);
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        }

        card.addEventListener('click', toggle);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });

        video.addEventListener('play', function () { card.classList.add('ugcwall__card--playing'); syncPaused(); });
        video.addEventListener('pause', function () { card.classList.remove('ugcwall__card--playing'); syncPaused(); });
      });

      // while any reel is playing, a click outside every card pauses it —
      // same effect as clicking the playing card itself. Cards are excluded
      // so their own toggle/switch behavior wins; capture phase so a
      // stopPropagation elsewhere can't swallow the click.
      document.addEventListener('click', function (e) {
        var withinCard = false;
        cards.forEach(function (c) { if (c.contains(e.target)) withinCard = true; });
        if (withinCard) return;
        root.querySelectorAll('.ugcwall__video').forEach(function (v) {
          if (!v.paused) v.pause();
        });
      }, true);
    }

    function boot() {
      document.querySelectorAll('[data-bs-ugc]').forEach(initUgc);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
